import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { LoginServico } from '../servicos/login.servico';
import { UtilServico } from '../servicos/util.servico';
import { Router, ActivatedRoute } from '@angular/router';
import { Console } from '@angular/core/src/console';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { DatePipe, registerLocaleData } from '@angular/common';
import { NativeDateAdapter, NativeDateModule, DateAdapter, MatDatepickerInputEvent, MatSelectChange, MatDialog } from '@angular/material';
import { CurrencyMaskModule } from "ngx-currency-mask";
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from "ngx-currency-mask/src/currency-mask.config";
import { FormControl, FormsModule, NgForm, FormBuilder, FormGroup, Validators, FormGroupDirective } from "@angular/forms";
import { ErrorStateMatcher, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ResponseContentType } from '@angular/http';
import { saveAs } from 'file-saver/FileSaver';
import { UtilDadosLogado } from '../servicos/util.logado';
import Swal from 'sweetalert2';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { map } from 'rxjs/operators';
import { Observable, forkJoin, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { errorObject } from 'rxjs/internal-compatibility';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { Body } from '@angular/http/src/body';
import { MatCalendar, MatCalendarCellCssClasses } from '@angular/material/datepicker';
import { MatTabGroup } from '@angular/material/tabs';
import { Directive, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { SecurityContext } from '@angular/core';
import { FeriasComponent } from './ferias/ferias.component';

declare var $: any;

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: "."
};

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

interface UploadedFile {
  name: string;
  fullName: string;
  file: any;
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export function matchValidator(fieldName: string) {
  let fcfirst: FormControl;
  let fcSecond: FormControl;

  return function matchValidator(control: FormControl) {

    if (!control.parent) {
      return null;
    }

    // INITIALIZING THE VALIDATOR.
    if (!fcfirst) {
      //INITIALIZING FormControl first
      fcfirst = control;
      fcSecond = control.parent.get(fieldName) as FormControl;

      //FormControl Second
      if (!fcSecond) {
        throw new Error('matchValidator(): Second control is not found in the parent group!');
      }

      fcSecond.valueChanges.subscribe(() => {
        fcfirst.updateValueAndValidity();
      });
    }

    if (!fcSecond) {
      return null;
    }

    if (fcSecond.value !== fcfirst.value) {
      return {
        matchOther: true
      };
    }

    return null;
  }
}

export class MyDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      // const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      // const month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
      // const year = date.getFullYear();
      // return `${day}/${month}/${year}`;
      return date.toLocaleDateString('pt-br');
    } else if (displayFormat == 'parse') {
      // return date.toDateString();
      return date.toLocaleString('pt-br', { month: "short" }) + " " + date.getFullYear();
    } else {
      return date.toLocaleDateString('pt-br');
    }
  }
}

export interface Perito {
  nome: string,
  atendimento_mat: string,
  disponibilidade: string,
  situacao: string,
  atendimento_vesp: string,
  disponibilidade_vesp: string,
  situacao_vesp: string,
  id: string
}


declare var swal: any;
declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-inicial',
  templateUrl: './inicial.component.html',
  styleUrls: ['./inicial.component.scss'],
  encapsulation: ViewEncapsulation.None,

  providers: [
    DatePipe,
    // { provide: DateAdapter, useClass: MyDateAdapter },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },

  ],
})

export class InicialComponent implements OnInit {

  @ViewChild(MatCalendar) matCalendar: MatCalendar<Date> | undefined;
  @ViewChild('myForm') myForm: NgForm;
  userForm: FormGroup;
  password = 'password';
  configuracoes: any;
  exibirAlteracaoSenha: any;
  pesquisar: any;
  Placar: any;
  DADOS: any;
  DADOS2: any;
  SENHA: any;
  TotalRegistro: number;
  exibirValorSimulacao: boolean;
  PaginaAtual: number = 1;
  PaginaTotal: number = 25;
  Mostrar: any;
  DADOSSIMULACAO: any;
  DADOSSIMULACAOESPONTANEA: any;
  DADOSPESSOAIS: any;
  RecadOnlineDados: any;
  RecadOnlineDadosOriginais: any;
  quantidadeDocumentosRecadOnline: number;
  ParametroRecadData: any;
  //RecadOnlineDadosDependete: any[] = [];
  RecadOnlineDadosDocumentos: any;
  ParametroRecadObritagorio: any;
  documentoSelecionado: any = null;
  podeBaixarDocumento: boolean = false;
  paramMes: boolean = false;
  paramPeriodoRecad: boolean = false;
  DADOSPROCESSO: any;
  DADOSRENDIMENTOS: any;
  EXPLICACAOREGRA: any;
  EXPLICACAOREGRAEXPONTANEA: any;
  ABONO_PERMANENCIA: any;
  DADOS_CEDENTE_BOLETO: any;
  public DADOCONTRIB: any;
  public DADOHOLERITE: any;
  public DADOSFICHA: any;
  public parametros: any;
  public parametrosSimulacao: any;
  public parametrosPortal: any;
  mostrarMSg: boolean = false;
  public arquivosprocesso_id: any;
  public ano: any;
  public name: any;
  public data: any;
  exibirCampo: boolean = false;
  SENHA_ELETRONICA: any;
  DADOS_RECADASTRAMENTO: any;
  DADOS_RECADASTRAMENTO_AGENDADO: any;
  RECAD_AGENDAMENTO: any;
  RECAD_LOCAL: any = {};
  Nome: any[] = [];
  dataInicial: Date;
  dataFinal: Date;
  RECADASTRAMENTOS: any[];
  filteredRecadastramentos: any[] = [];
  searchText: string = '';
  tituloDocumento: string = '';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  RECADASTRAMENTOSRECUPERADO: any[];
  PossuiVencimento: boolean = false;

  public currentTabIndex: number = 0;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  public totalTabs: number = 5;

  get paginatedRecadastramentos(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.filteredRecadastramentos.slice(startIndex, endIndex);
  }

  public sub = "http://localhost:62195/api/Inicial/";
  //public sub = "http://implantacao.sisprevweb.com.br/webapiportalsergipe/api/Inicial/";
  //public sub = "http://implantacao.sisprevweb.com.br/PortalAl/webapiportalsergipe/api/Inicial/";
  //public sub = "http://proxima.sisprevweb.com.br/NovoPortalSergipe/webapiportalsergipe/api/Inicial/";
  //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipe/api/Inicial/";
  //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipehomologacao/api/Inicial/";
  meses = [];
  documentosObrigatorios: UploadedFile[] = [];
  links = [];
  anos = [];
  cidadesReq = [];
  ufReq = [];
  cidadesProcReq = [];
  cidadesInst = [];
  processoId: any;
  ufProcReq = [];
  uf = [];
  nrProcesso: any;
  chk_list = [];
  chkListId: any = 0;
  gerouRequerimento: boolean = false;
  tipoDependenteUnico: boolean = false;
  instituidores = [];
  cidades = [];
  cidadesNacionalidade = [];
  segurados = [];
  nacionalidade = [];
  raca = [];
  FALE: any;
  requerimentoArquivo: File;
  assunto = [];
  BOLETOS_PORTAL = [];
  AnexoProcesso = [];
  uploadFileIndexToInsert: number;

  // Variáveis para o upload
  documentoArquivo: any[] = [];
  docDadosRecOnline: any[] = [];
  pdfBase64: string | null = null;
  imageBase64: string | null = null;
  fileArq: File | null = null;
  uploadedFile: File | null = null;
  pdfUrl: SafeResourceUrl | null = null;
  imageUrl: SafeResourceUrl | null = null;
  documentosAdicionados: any[] = [];
  displayedColumns: string[] = ['excluir', 'nome', 'arquivo'];

  RecadOnlineDadosDependete: any[] = [];
  showDependenteModal: boolean = false;
  editando: boolean = false;
  indexEdicao: number | null = null;

  listaSexo = [
    { id: "M", Nome: "Masculino" },
    { id: "F", Nome: "Feminino" },
  ];

  listaParentesco = [
    { id: 1, descricao: "CÔNJUGE" },
    { id: 2, descricao: "FILHO(A)" },
    { id: 3, descricao: "MÃE/PAI" },
    { id: 4, descricao: "IRMÃO NÃO EMANCIPADO" },
    { id: 5, descricao: "CURADOR" },
    { id: 6, descricao: "COMPANHEIRO(A)" },
    { id: 7, descricao: "EX-CÔNJUGE" },
    { id: 8, descricao: "MENOR POBRE COM GUARDA JUDICIAL" },
    { id: 9, descricao: "AVÔ/AVÓ" },
    { id: 10, descricao: "BISAVÔ/BISAVÓ" },
    { id: 11, descricao: "ENTEADO(A)" },
    { id: 12, descricao: "EX-COMPANHEIRO(A)" },
    { id: 13, descricao: "INDENIZAÇÃO TERCEIROS" },
    { id: 14, descricao: "IRMÃO COM GUARDA JUDICIAL" },
    { id: 15, descricao: "NETO COM GUARDA JUDICIAL" },
    { id: 16, descricao: "TUTOR" },
    { id: 17, descricao: "MENOR TUTELADO" },
    { id: 99, descricao: "OUTROS" }
  ];

  listaEscolaridade = [
    { ESCOLARIDADE_ID: 1, descricao: "ANALFABETO, INCLUSIVE O QUE, EMBORA TENHA RECEBIDO INSTRUÇÃO, NÃO SE ALFABETIZOU." },
    { ESCOLARIDADE_ID: 2, descricao: "ATÉ A 4ª SÉRIE INCOMPLETA DO ENSINO FUNDAMENTAL (ANTIGO 1º GRAU OU PRIMÁRIO) QUE SE TENHA ALFABETIZADO SEM TER FREQUENTADO ESCOLA REGULAR." },
    { ESCOLARIDADE_ID: 3, descricao: "4ª SÉRIE COMPLETA DO ENSINO FUNDAMENTAL (ANTIGO 1º GRAU OU PRIMÁRIO)." },
    { ESCOLARIDADE_ID: 4, descricao: "DA 5ª A 8ª SÉRIE DO ENSINO FUNDAMENTAL (ANTIGO 1º GRAU OU GINÁSIO)." },
    { ESCOLARIDADE_ID: 5, descricao: "ENSINO FUNDAMENTAL COMPLETO (ANTIGO 1º GRAU OU PRIMÁRIO E GINASIAL)." },
    { ESCOLARIDADE_ID: 6, descricao: "ENSINO MÉDIO INCOMPLETO (ANTIGO 2º GRAU, SECUNDÁRIO OU COLEGIAL)." },
    { ESCOLARIDADE_ID: 7, descricao: "ENSINO MÉDIO COMPLETO (ANTIGO 2º GRAU, SECUNDÁRIO OU COLEGIAL)." },
    { ESCOLARIDADE_ID: 8, descricao: "EDUCAÇÃO SUPERIOR INCOMPLETA." },
    { ESCOLARIDADE_ID: 9, descricao: "EDUCAÇÃO SUPERIOR COMPLETA." },
    { ESCOLARIDADE_ID: 10, descricao: "PÓS-GRADUAÇÃO." },
    { ESCOLARIDADE_ID: 11, descricao: "MESTRADO." },
    { ESCOLARIDADE_ID: 12, descricao: "DOUTORADO." },
    { ESCOLARIDADE_ID: 13, descricao: "ESPECIALIZAÇÃO." }
  ];

  public sexo: Array<Object> = [
    { ID: 'M', NOME: 'Masculino' },
    { ID: 'F', NOME: 'Feminino' }
  ];
  public estadocivil: Array<Object> = [
    { ID: 0, NOME: 'SOLTEIRO(A)' },
    { ID: 1, NOME: 'CASADO(A)' },
    { ID: 2, NOME: 'VIÚVO(A)' },
    { ID: 3, NOME: 'DIVORCIADO(A)' },
    { ID: 4, NOME: 'DESQUITADO(A)' },
    { ID: 5, NOME: 'AMASIADO(A)' },
    { ID: 6, NOME: 'OUTROS(A)' },
    { ID: 7, NOME: 'UNIÃO ESTÁVEL' },
    { ID: 8, NOME: 'SEPARADO JUDICIALMENTE' }
  ];
  public apos: Array<Object> = [
    { ID: 'S', NOME: 'Sim - Professor' },
    { ID: 'N', NOME: 'Não' }
  ];
  public mes: Array<Object> = [
    { ID: 1, NOME: 'Janeiro' },
    { ID: 2, NOME: 'Fevereiro' },
    { ID: 3, NOME: 'Março' },
    { ID: 4, NOME: 'Abril' },
    { ID: 5, NOME: 'Maio' },
    { ID: 6, NOME: 'Junho' },
    { ID: 7, NOME: 'Julho' },
    { ID: 8, NOME: 'Agosto' },
    { ID: 9, NOME: 'Setembro' },
    { ID: 10, NOME: 'Outubro' },
    { ID: 11, NOME: 'Novembro' },
    { ID: 12, NOME: 'Dezembro' },
  ];
  public logradouro: Array<Object> = [
    { ID: 8, NOME: 'Avenida' },
    { ID: 81, NOME: 'Rua' },
    { ID: 100, NOME: 'Travessa' },
    { ID: 77, NOME: 'Quadra' },
    { ID: 65, NOME: 'Praça' },
    { ID: 104, NOME: 'Vila' },
    { ID: 4, NOME: 'Alameda' },
    { ID: 31, NOME: 'Estrada' },
    { ID: 90, NOME: 'Rodovia' },
    { ID: 105, NOME: 'Assentamento' },
    { ID: 106, NOME: 'Condomínio' },
    { ID: 107, NOME: 'Conjunto' },
    { ID: 108, NOME: 'Distrito' },
    { ID: 109, NOME: 'Fazenda' },
    { ID: 110, NOME: 'Jardim' },
    { ID: 111, NOME: 'Loteamento' },
    { ID: 112, NOME: 'Parque' },
    { ID: 113, NOME: 'Povoado' },
    { ID: 114, NOME: 'Sítio' },
  ];
  selectedAssunto: any;
  selectedAssuntoId: any;
  public resultados = [];
  FormControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  novoDependente: any = {
    NOME: '',
    DATA_NASC: '',
    CPF: '',
    PARENTESCO: null,
    DATA_INI_DEP: ''
  };

  matcher = new MyErrorStateMatcher();
  zoom_to: number = 1;
  bytesPdf: any;
  bytesPdfTitle = "";
  tipoPericia = "GM";
  motivoPericia = "";
  motivosPericia = [];
  datasPericia = [];
  dataPericia: Date = null;
  peritos: Perito[];
  perguntasFrequentes = [];
  informativos = [];
  dadosEnquete: any;
  mostrarEnquete: boolean = false;
  mostrarAnexos: boolean = false;
  selecionouGridPadrao: boolean;
  permiteAberturaDeProcessos: boolean;
  selecionouAbertura: boolean;
  public etapaAberturaProcesso: number;
  public etapaTabProcesso: number;
  tipoCheckListaNome: string;
  beneficioSelecionado: any;
  nomeSolicitacao: string;
  dpPericiaFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();

    //desabilita sabados e domingos
    if (day == 0 || day == 6)
      return false;

    const ano = d.getFullYear();
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const dia = String(d.getDate()).padStart(2, '0');

    const shortDate = `${ano}-${mes}-${dia}`;

    //remove os dias que não estiverem habilitados
    if (this.datasPericia.find((_d) => _d == shortDate) == null)
      return false;

    return true;
  }

  dpPericiaClass = (d: Date) => {
    const day = d.getDay();

    if (day == 0 || day == 6)
      return undefined;

    let today = new Date();
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (d < today)
      return undefined;

    const ano = d.getFullYear();
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const dia = String(d.getDate()).padStart(2, '0');

    const shortDate = `${ano}-${mes}-${dia}`;

    if (this.datasPericia.find((_d) => _d == shortDate) != null)
      return 'highlight-dates';

    return 'highlight-disabled-dates'
  }

  minDataPericia = new Date();

  constructor(
    private fBuilder: FormBuilder,
    private http: Http,
    private LoginServico: LoginServico,
    private UtilServico: UtilServico,
    private router: Router,
    private datePipe: DatePipe,
    private dateAdapter: DateAdapter<MyDateAdapter>,
    private formBuilder: FormBuilder,
    private UtilDadosLogado: UtilDadosLogado,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog,
  ) {
    this.dateAdapter.setLocale('pt');
    this.exibirAlteracaoSenha = JSON.parse(localStorage.getItem('exibirAlteracaoSenha'));

  }

  ngOnInit() {

    this.configuracoes = JSON.parse(localStorage.getItem('DadosConfiguracoes'));

    this.configuracoes.DATA_ULTIMO_ACESSO = this.datePipe.transform(this.configuracoes.DATA_ULTIMO_ACESSO, 'dd/MM/yyyy HH:mm:ss')
    this.pesquisar = { PesquisarPor: 1, CadastroInLoco: "T", Concluido: "T", Categoria: 1 };
    this.DADOS = {};
    this.DADOS2 = {};
    this.DADOSSIMULACAO = { Codigo: 0 };
    this.DADOSSIMULACAOESPONTANEA = { Codigo: 0 };
    this.DADOCONTRIB = { MES_INICIO: new Date().getMonth() + 1, ANO_INICIO: new Date().getFullYear(), MES_FIM: new Date().getMonth() + 1, ANO_FIM: new Date().getFullYear() };
    this.SENHA = {};
    this.FALE = {};
    this.EXPLICACAOREGRA = {};
    this.DADOSPESSOAIS = {};
    this.RecadOnlineDados = {};
    this.RecadOnlineDadosOriginais = {};
    this.quantidadeDocumentosRecadOnline = 0;
    this.RecadOnlineDadosDependete = [];
    this.RecadOnlineDadosDocumentos = [];
    this.reiniciarProcesso();
    this.parametros = {};
    this.DADOHOLERITE = { MES: new Date().getMonth() + 1, ANO: new Date().getFullYear() };
    this.DADOSFICHA = { ANO: new Date().getFullYear() };
    this.DADOSRENDIMENTOS = { ANO: new Date().getFullYear() - 1 };
    this.GetSegurados();
    this.GetParametros();
    this.GetParametrosSimulacao();
    this.GetParametrosCategoriasPortal();
    this.ExibirModalAlteracaoSenha();
    this.Links();
    this.InformativoVisualizado();
    this.ConsultarEnquete();
    this.ValidarNotificacao();
    this.VerificaPericiaMedica();
    this.VerificaPossuiVencimento();

    $('#ModalRecadastramentoOnline').on('shown.bs.modal', () => {
      this.resetModal();
      this.documentosAdicionados = [];
      this.podeBaixarDocumento = false;
    });

    this.DADOS_RECADASTRAMENTO_AGENDADO = {
      Periodo: 'null',
      Local: '',
      DataRecadastramento: '',
      Horario: ''
    };
    const docDadosRecOnline = {
      dados: null
    };
    this.GetDadosRecad();

    this.GetDados();


    this.DADOS_RECADASTRAMENTO = {
      Periodo: null,
      Email: '',
      Telefone: '',
      Declarante: '',
      Local: '',
      Segurado: this.configuracoes.MAT_ORG + ' - ' + this.configuracoes.NOME,
      Cpf: this.configuracoes.LOGIN,
      DataRecadastramento: '',
      Categoria: this.configuracoes.CATEGORIA,
      SeguradoId: this.configuracoes.SEGURADO_ID,
      LocalId: ''
    };



  }

  VerificaPossuiVencimento() {
    this.Mostrar = true;

    this.UtilServico.Get("GetPossuiVencimento?seguradoId=" + this.configuracoes.SEGURADO_ID).subscribe(
      (response: any) => {
        this.PossuiVencimento = response && response.length > 0; // Armazena true se houver registros
      }
    );
    this.Mostrar = false;
  }

  openDialogFerias() {
    let dialogRef = this.dialog.open(FeriasComponent, {
      width: 'auto',
      maxWidth: '90vw',
      height: 'auto',
      maxHeight: '95vh',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog',
      data: {
        usuarioId: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID, seguradoId: this.configuracoes.SEGURADO_ID, nomeSegurado: this.configuracoes.NOME, matriculaSegurado: this.configuracoes.MAT_ORG, Url: this.UtilDadosLogado.DadosAcesso().URL
      }
    });
  }

  ngTeste() {

  }

  ngDoCheck(): void {

  }

  reiniciarProcesso() {
    this.chk_list = [{
      ID: 0,
      NOME: "Selecione"
    }];

    this.chkListId = 0;

    this.gerouRequerimento = false;
    this.requerimentoArquivo = null;
    this.processoId = 0;
    this.beneficioSelecionado = null;

    this.documentosObrigatorios = [];
    this.etapaAberturaProcesso = 0;
    this.etapaTabProcesso = 0;

    $("#hddFileUpload")[0].value = "";

    this.cidadesProcReq = [];
    this.ufProcReq = [];

    this.cidadesReq = [];
    this.ufReq = [];

    this.cidadesInst = [];

    this.DADOSPROCESSO = {
      TIPO_PROCESSO: 'A',
      TIPO_CHECKLIST: '0',
      PENSAO_PROPRIA: 'S',
      TIPO_DEPENDENTE: '1',
      RECEBE_PENSAO: 'N',
      ADERIR_AO_SC_SAUDE: 'N',
      ORGAO_VINCULO: '1',
      SITUACAO_NO_OBITO: 'A',
      PENSAO_NAO_PROPRIA: '',
      PROC_REQ_NOME: '',
      PROC_REQ_CPF: '',
      PROC_REQ_EMAIL: '',
      PROC_REQ_FONE: '',
      PROC_REQ_RG: '',
      PROC_REQ_ORG_EXP: '',
      PROC_REQ_CEP: '',
      PROC_REQ_LOGR: '',
      PROC_REQ_BAIRRO: '',
      PROC_REQ_COMP: '',
      PROC_REQ_UF: '',
      PROC_REQ_CIDADE: '',
      PROC_REQ_TIPO_VINC_REQ: '0',
      REQUERENTE_NOME: '',
      REQUERENTE_CPF: '',
      REQUERENTE_SEXO: '0',
      REQUERENTE_DATA_NASC: '',
      REQUERENTE_EMAIL: '',
      REQUERENTE_FONE: '',
      REQUERENTE_CEP: '',
      REQUERENTE_LOGR: '',
      REQUERENTE_BAIRRO: '',
      REQUERENTE_NUMERO: '',
      REQUERENTE_UF: '',
      REQUERENTE_CIDADE: '',
      REQUERENTE_COMP: '',
      REQUERENTE_RESIDENCIA: '1',
      REQUERENTE_ANOS: '0',
      REQUERENTE_MESES: '0',
      REQUERENTE_RG: '',
      REQUERENTE_ORG_EXP: '',
      REQUERENTE_UF_EXP: '',
      REQUERENTE_PROFISSAO: '',
      REQUERENTE_AGENCIA: '',
      REQUERENTE_CONTA: '',
      REQUERENTE_MAE: '',
      REQUERENTE_DATA_CONV: '',
      REQUERENTE_JA_CASOU: 'N',
      REQUERENTE_HA_FILHOS: 'N',
      REQUERENTE_CERT_DEC: 'N',
      REQUERENTE_DOENCA: '',
      REQUERENTE_CID: '',
      REQUERENTE_DATA_DIAG: '',
      REQUERENTE_GRAU: '1',
      REQUERENTE_ESTADO_CIVIL: '1',
      REQUERENTE_EXE_LABO: 'N',
      REQUERENTE_TIPO_DOC_DIVOR: '',
      REQUERENTE_CONJ_ATIV_LABO: 'N',
      REQUERENTE_MAE_CPF: '',
      INSTITUIDOR_NOME: '',
      INSTITUIDOR_CPF: '',
      INSTITUIDOR_SEXO: '',
      INSTITUIDOR_DATA_NASC: '',
      INSTITUIDOR_DATA_OBITO: '',
      INSTITUIDOR_DATA_EX_CERT_OBI: '',
      INSTITUIDOR_MAT_ORG: '',
      INSTITUIDOR_DATA_INI_SERV_PUB: '',
      INSTITUIDOR_NUM_RG: '',
      INSTITUIDOR_ORG_EXP: '',
      INSTITUIDOR_UF_EXP: '',
      INSTITUIDOR_CEP: '',
      INSTITUIDOR_LOGR: '',
      INSTITUIDOR_BAIRRO: '',
      INSTITUIDOR_NUMERO: '',
      INSTITUIDOR_COMP: '',
      INSTITUIDOR_UF: '',
      INSTITUIDOR_CIDADE: '',
      INSTITUIDOR_JA_CASOU: 'N',
      INSTITUIDOR_ULTIMO_SALARIO: '',
      INSTITUIDOR_CARGO: '',
      INSTITUIDOR_ID: ''
    };
  }

  limparInst(): void {
    this.DADOSPROCESSO.INSTITUIDOR_NOME = '';
    this.DADOSPROCESSO.INSTITUIDOR_CPF = '';
    this.DADOSPROCESSO.INSTITUIDOR_SEXO = '';
    this.DADOSPROCESSO.INSTITUIDOR_DATA_NASC = '';
    this.DADOSPROCESSO.INSTITUIDOR_DATA_OBITO = '';
    this.DADOSPROCESSO.INSTITUIDOR_DATA_EX_CERT_OBI = '';
    this.DADOSPROCESSO.INSTITUIDOR_MAT_ORG = '';
    this.DADOSPROCESSO.INSTITUIDOR_DATA_INI_SERV_PUB = '';
    this.DADOSPROCESSO.INSTITUIDOR_NUM_RG = '';
    this.DADOSPROCESSO.INSTITUIDOR_ORG_EXP = '';
    this.DADOSPROCESSO.INSTITUIDOR_UF_EXP = '';
    this.DADOSPROCESSO.INSTITUIDOR_CEP = '';
    this.DADOSPROCESSO.INSTITUIDOR_LOGR = '';
    this.DADOSPROCESSO.INSTITUIDOR_BAIRRO = '';
    this.DADOSPROCESSO.INSTITUIDOR_NUMERO = '';
    this.DADOSPROCESSO.INSTITUIDOR_COMP = '';
    this.DADOSPROCESSO.INSTITUIDOR_UF = '';
    this.DADOSPROCESSO.INSTITUIDOR_CIDADE = '';
    this.DADOSPROCESSO.INSTITUIDOR_JA_CASOU = 'N';
    this.DADOSPROCESSO.INSTITUIDOR_ULTIMO_SALARIO = '';
    this.DADOSPROCESSO.INSTITUIDOR_CARGO = '';
    this.DADOSPROCESSO.INSTITUIDOR_ID = '';
    this.cidadesInst = [];
  }

  limparProcRec(): void {
    this.DADOSPROCESSO.PROC_REQ_NOME = '';
    this.DADOSPROCESSO.PROC_REQ_CPF = '';
    this.DADOSPROCESSO.PROC_REQ_EMAIL = '';
    this.DADOSPROCESSO.PROC_REQ_FONE = '';
    this.DADOSPROCESSO.PROC_REQ_RG = '';
    this.DADOSPROCESSO.PROC_REQ_ORG_EXP = '';
    this.DADOSPROCESSO.PROC_REQ_CEP = '';
    this.DADOSPROCESSO.PROC_REQ_LOGR = '';
    this.DADOSPROCESSO.PROC_REQ_BAIRRO = '';
    this.DADOSPROCESSO.PROC_REQ_COMP = '';
    this.DADOSPROCESSO.PROC_REQ_UF = '';
    this.DADOSPROCESSO.PROC_REQ_CIDADE = '';
    this.DADOSPROCESSO.PROC_REQ_TIPO_VINC_REQ = '0';
    this.cidadesProcReq = [];
    this.ufProcReq = [];
  }

  limparRec(): void {
    this.DADOSPROCESSO.REQUERENTE_NOME = '';
    this.DADOSPROCESSO.REQUERENTE_CPF = '';
    this.DADOSPROCESSO.REQUERENTE_SEXO = '';
    this.DADOSPROCESSO.REQUERENTE_DATA_NASC = '';
    this.DADOSPROCESSO.REQUERENTE_EMAIL = '';
    this.DADOSPROCESSO.REQUERENTE_FONE = '';
    this.DADOSPROCESSO.REQUERENTE_CEP = '';
    this.DADOSPROCESSO.REQUERENTE_LOGR = '';
    this.DADOSPROCESSO.REQUERENTE_BAIRRO = '';
    this.DADOSPROCESSO.REQUERENTE_NUMERO = '';
    this.DADOSPROCESSO.REQUERENTE_UF = '';
    this.DADOSPROCESSO.REQUERENTE_CIDADE = '';
    this.DADOSPROCESSO.REQUERENTE_COMP = '';
    this.DADOSPROCESSO.REQUERENTE_RESIDENCIA = '1';
    this.DADOSPROCESSO.REQUERENTE_ANOS = '0';
    this.DADOSPROCESSO.REQUERENTE_MESES = '0';
    this.DADOSPROCESSO.REQUERENTE_RG = '';
    this.DADOSPROCESSO.REQUERENTE_ORG_EXP = '';
    this.DADOSPROCESSO.REQUERENTE_UF_EXP = '';
    this.DADOSPROCESSO.REQUERENTE_PROFISSAO = '';
    this.DADOSPROCESSO.REQUERENTE_AGENCIA = '';
    this.DADOSPROCESSO.REQUERENTE_CONTA = '';
    this.DADOSPROCESSO.REQUERENTE_MAE = '';
    this.DADOSPROCESSO.REQUERENTE_DATA_CONV = '';
    this.DADOSPROCESSO.REQUERENTE_JA_CASOU = 'N';
    this.DADOSPROCESSO.REQUERENTE_HA_FILHOS = 'N';
    this.DADOSPROCESSO.REQUERENTE_CERT_DEC = 'N';
    this.DADOSPROCESSO.REQUERENTE_DOENCA = '';
    this.DADOSPROCESSO.REQUERENTE_CID = '';
    this.DADOSPROCESSO.REQUERENTE_DATA_DIAG = '';
    this.DADOSPROCESSO.REQUERENTE_GRAU = '1';
    this.DADOSPROCESSO.REQUERENTE_ESTADO_CIVIL = '1';
    this.DADOSPROCESSO.REQUERENTE_EXE_LABO = 'N';
    this.DADOSPROCESSO.REQUERENTE_TIPO_DOC_DIVOR = ''
    this.DADOSPROCESSO.REQUERENTE_CONJ_ATIV_LABO = 'N'
    this.DADOSPROCESSO.REQUERENTE_MAE_CPF = '';
    this.cidadesReq = [];
    this.ufReq = [];
  }

  onChangeTipoDependente(): void {
    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == "5" || this.DADOSPROCESSO.TIPO_DEPENDENTE == "3" || this.DADOSPROCESSO.TIPO_DEPENDENTE == "10" || this.DADOSPROCESSO.TIPO_DEPENDENTE == "6" || this.DADOSPROCESSO.TIPO_DEPENDENTE == "7") {
      if (this.DADOSPROCESSO.TIPO_DEPENDENTE == "5") {
        this.DADOSPROCESSO.REQUERENTE_ESTADO_CIVIL = '5';
      }

      if (this.DADOSPROCESSO.TIPO_DEPENDENTE == "3" || this.DADOSPROCESSO.TIPO_DEPENDENTE == "10") {
        this.DADOSPROCESSO.REQUERENTE_ESTADO_CIVIL = '';
        this.DADOSPROCESSO.REQUERENTE_GRAU = '';
      }

      if (this.DADOSPROCESSO.TIPO_DEPENDENTE == "6") {
        this.DADOSPROCESSO.REQUERENTE_ESTADO_CIVIL = '5';
        this.DADOSPROCESSO.REQUERENTE_TIPO_DOC_DIVOR = '';
      }

      if (this.DADOSPROCESSO.TIPO_DEPENDENTE == "7") {
        this.DADOSPROCESSO.REQUERENTE_ESTADO_CIVIL = '5';
        this.DADOSPROCESSO.REQUERENTE_GRAU = '';
      }
    } else {
      this.DADOSPROCESSO.REQUERENTE_ESTADO_CIVIL = '1';
      this.DADOSPROCESSO.REQUERENTE_GRAU = '1';
      this.DADOSPROCESSO.REQUERENTE_TIPO_DOC_DIVOR = '';
    }

    this.DADOSPROCESSO.REQUERENTE_MAE = '';
    this.DADOSPROCESSO.REQUERENTE_DATA_CONV = '';
    this.DADOSPROCESSO.REQUERENTE_JA_CASOU = 'N';
    this.DADOSPROCESSO.REQUERENTE_HA_FILHOS = 'N';
    this.DADOSPROCESSO.REQUERENTE_CERT_DEC = 'N'
    this.DADOSPROCESSO.REQUERENTE_DOENCA = '';
    this.DADOSPROCESSO.REQUERENTE_CID = '';
    this.DADOSPROCESSO.REQUERENTE_DATA_DIAG = '';
    this.DADOSPROCESSO.REQUERENTE_EXE_LABO = 'N';
    this.DADOSPROCESSO.REQUERENTE_CONJ_ATIV_LABO = 'N';
    this.DADOSPROCESSO.REQUERENTE_MAE_CPF = '';
  }

  onChangeProcuradorRepresentante(event: any, type: string): void {
    switch (type) {
      case 'P':
        this.DADOSPROCESSO.PENSAO_NAO_PROPRIA = event.checked ? 'P' : '';
        break;
      case 'R':
        this.DADOSPROCESSO.PENSAO_NAO_PROPRIA = event.checked ? 'R' : '';
        break;
    }

    this.limparProcRec();
  }

  onChangePensaoPropria(event: any): void {
    if (event.value == 'S') {
      $("#chkProcurador").checked = false;
      $("#chkRepresentante").checked = false;

      this.DADOSPROCESSO.PENSAO_NAO_PROPRIA = '';

      this.limparProcRec();
    }
  }

  CarregarGridInicial(currentPage: number) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.UtilServico.Post("GetProcesso", JSON.stringify({ PESSOA_ID: this.configuracoes.PESSOA_ID, SEGURADO_ID: this.configuracoes.SEGURADO_ID, USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID.toString() }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
          if (this.TotalRegistro == 0) {
            swal({
              title: "Atenção!",
              type: "error",
              text: "Nenhum processo encontrado"
            });
          }
        },
        error => {

        }
      );
  }

  public pageChanged(event: any): void {
    this.PaginaAtual = event;
    this.CarregarGridInicial(event);
  }

  public EditarClick() {
    this.selecionouAbertura = false;
    this.selecionouGridPadrao = false;
    if (!this.permiteAberturaDeProcessos) {
      this.CarregarGridInicial(1);
    } else {
      this.reiniciarProcesso();
    }
  }

  public VisualizarRecadastrados() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.UtilServico.Get("GetDadosRecadastrados?SEGURADO_ID=" + this.configuracoes.SEGURADO_ID).subscribe(
      data => {
        this.RECADASTRAMENTOS = data || [];
        this.filteredRecadastramentos = [this.RECADASTRAMENTOS];
        this.RECADASTRAMENTOSRECUPERADO = this.RECADASTRAMENTOS;
        this.currentPage = 1;
        this.Mostrar = false;
        if (this.TotalRegistro == 0) {
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum processo encontrado"
          });
        }
      },
      error => {

      }
    );

  }


  EmitirProtocoloFeito(recadastramentoId: string) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers, responseType: 2 }); // `2` corresponde a `ResponseContentType.Blob`
    options.responseType = ResponseContentType.Blob;
    console.log('aqui')


    if (recadastramentoId != null && recadastramentoId != "") {
      this.UtilServico.Get("EmitirProtocoloFeito?recadastramentoId=" + recadastramentoId, options)
        .subscribe(
          data => {
            this.Mostrar = false;
            var file = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          },
          error => {
            this.Mostrar = false;
          }
        );

    } else {
      Swal.fire({
        title: "Atenção!",
        text: "Não foi feito o recadastramento referente a esse ano!"
      });
      this.Mostrar = false;
    }
  }


  filterRecords() {
    if (this.searchText) {
      const searchTextLower = this.searchText.toLowerCase();
      this.filteredRecadastramentos = this.RECADASTRAMENTOS.filter(item =>
        (item.NrProtocolo && item.NrProtocolo.toString().toLowerCase().includes(searchTextLower)) ||
        (item.NomeBeneficio && item.NomeBeneficio.toLowerCase().includes(searchTextLower)) ||
        (item.AnoReferencia && item.AnoReferencia.toString().includes(searchTextLower)) ||
        (item.Matricula && item.Matricula.toLowerCase().includes(searchTextLower)) ||
        (item.Usuario && item.Usuario.toLowerCase().includes(searchTextLower)) ||
        (item.Situacao && item.Situacao.toLowerCase().includes(searchTextLower))
      );
      this.RECADASTRAMENTOS = this.filteredRecadastramentos;
    } else {
      this.filteredRecadastramentos = [this.RECADASTRAMENTOS];
      this.RECADASTRAMENTOS = this.RECADASTRAMENTOSRECUPERADO;
    }
    this.currentPage = 1;
  }





  totalPages(): number {
    return Math.ceil(this.filteredRecadastramentos.length / this.itemsPerPage);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages()) {
      this.currentPage = page;
    }
  }


  public selecionarAbertura() {
    this.selecionouAbertura = !this.selecionouAbertura;
    this.selecionouGridPadrao = false;

    if (this.selecionouAbertura)
      this.SelecionarTipoProcesso();
  }

  public showDefaultProcessos() {
    this.selecionouGridPadrao = !this.selecionouGridPadrao;
    this.selecionouAbertura = false;

    if (this.selecionouGridPadrao)
      this.CarregarGridInicial(1);
  }

  public SelecionarTipoProcesso() {
    this.beneficioSelecionado = undefined;
    this.DADOSPROCESSO.TIPO_CHECKLIST = '0';

    if (this.DADOSPROCESSO.TIPO_PROCESSO) {
      switch (this.DADOSPROCESSO.TIPO_PROCESSO) {
        case "A":
          this.nomeSolicitacao = "SOLICITAÇÃO DE SERVIÇOS";
          break;
        case "B":
          this.nomeSolicitacao = "SOLICITAÇÃO DE BENEFÍCIO";
          break;
        default:
          this.nomeSolicitacao = "SOLICITAÇÃO DE BENEFÍCIO";
          break;
      }

      this.carregarProcessosBeneficio();
    }
  }

  public SelecionarTipoCheckList(change: MatSelectChange) {
    var selectedData = {
      value: change.value,
      text: change.source.triggerValue
    };

    this.documentosObrigatorios = [];
    $("#hddFileUpload")[0].value = "";

    let beneficioSelecionado = this.chk_list.filter((obj) => {
      return obj.ID === change.value;
    });

    if (beneficioSelecionado[0].TIPO_DEPENDENTE != "0") {
      this.DADOSPROCESSO.TIPO_DEPENDENTE = beneficioSelecionado[0].TIPO_DEPENDENTE;
      this.tipoDependenteUnico = true;
    } else {
      this.DADOSPROCESSO.TIPO_DEPENDENTE = "1";
      this.tipoDependenteUnico = false;
    }

    this.chkListId = change.value;
    this.tipoCheckListaNome = selectedData.text;

    this.beneficioSelecionado = beneficioSelecionado[0];

  }

  abrirPesquisaInstituidor(): void {
    if (this.DADOSPROCESSO.INSTITUIDOR_ID) {
      Swal.fire({
        title: "Atenção!",
        text: "JÁ EXISTE CADASTRO SELECIONADO"
      });
    } else {
      $("#ModalMeusProcessos").hide();
      $("#ModalPesquisaInstuidor").show();
      this.instituidores = [];
    }
  }

  limparInstituidor(): void {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja desfazer a seleção e apagar o preenchimento dos campos?",
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'SIM',
      cancelButtonText: 'NÃO'
    }).then((result) => {
      if (result.value) {
        this.limparInst();
      }
    });
  }

  selecionarInstituidor(index: number): void {
    this.DADOSPROCESSO.INSTITUIDOR_NOME = this.instituidores[index].NOME;
    this.DADOSPROCESSO.INSTITUIDOR_CPF = this.instituidores[index].CPF;
    this.DADOSPROCESSO.INSTITUIDOR_SEXO = this.instituidores[index].SEXO;
    this.DADOSPROCESSO.INSTITUIDOR_DATA_NASC = this.instituidores[index].DATA_NASC;
    this.DADOSPROCESSO.INSTITUIDOR_DATA_OBITO = this.instituidores[index].DATA_OBITO;
    this.DADOSPROCESSO.INSTITUIDOR_DATA_EX_CERT_OBI = this.instituidores[index].DT_EMISSAO_CERTIDAO;
    this.DADOSPROCESSO.INSTITUIDOR_MAT_ORG = this.instituidores[index].MAT_ORG;
    this.DADOSPROCESSO.INSTITUIDOR_DATA_INI_SERV_PUB = this.instituidores[index].DATA_ADM;
    this.DADOSPROCESSO.INSTITUIDOR_NUM_RG = this.instituidores[index].RG_NUMERO;
    this.DADOSPROCESSO.INSTITUIDOR_ORG_EXP = this.instituidores[index].RG_ORGAO;
    this.DADOSPROCESSO.INSTITUIDOR_UF_EXP = this.instituidores[index].RG_UF;
    this.DADOSPROCESSO.INSTITUIDOR_CEP = this.instituidores[index].END_CEP;
    this.DADOSPROCESSO.INSTITUIDOR_LOGR = this.instituidores[index].END_RUA;
    this.DADOSPROCESSO.INSTITUIDOR_BAIRRO = this.instituidores[index].END_BAIRRO;
    this.DADOSPROCESSO.INSTITUIDOR_NUMERO = this.instituidores[index].END_NUMERO;
    this.DADOSPROCESSO.INSTITUIDOR_COMP = this.instituidores[index].END_COMPLEMENTO;
    this.DADOSPROCESSO.INSTITUIDOR_UF = this.instituidores[index].END_UF;
    this.DADOSPROCESSO.INSTITUIDOR_CIDADE = this.instituidores[index].END_CIDADE_ID;
    this.DADOSPROCESSO.INSTITUIDOR_ULTIMO_SALARIO = this.instituidores[index].VALOR;
    this.DADOSPROCESSO.INSTITUIDOR_CARGO = this.instituidores[index].CARGO_NOME;
    this.DADOSPROCESSO.INSTITUIDOR_ID = this.instituidores[index].SEGURADO_ID;

    if (this.DADOSPROCESSO.INSTITUIDOR_CIDADE && !this.DADOSPROCESSO.INSTITUIDOR_UF) {
      this.Mostrar = true;

      this.GetUfByCidade(this.DADOSPROCESSO.INSTITUIDOR_CIDADE).then((estado) => {
        this.Mostrar = false;

        this.DADOSPROCESSO.INSTITUIDOR_UF = estado;


        $("#ModalPesquisaInstuidor").hide();
        $("#ModalMeusProcessos").show();

        this.GetCidadesInst(false);
      });
    } else {
      $("#ModalPesquisaInstuidor").hide();
      $("#ModalMeusProcessos").show();

      this.GetCidadesInst(false);
    }
  }

  fecharPesquisaInstituidor(): void {
    $("#ModalMeusProcessos").show();
    $("#ModalPesquisaInstuidor").hide();
  }

  public AvancarEtapaAberturaProcesso() {
    var errorMessage = "Ausência de preenchimento dos seguintes campos:\n";
    var noError = errorMessage.length;

    if (this.DADOSPROCESSO.TIPO_PROCESSO != "A" && this.beneficioSelecionado.BENEFICIO_ID == "7") {
      switch (this.etapaAberturaProcesso) {
        case 1:
          if (this.DADOSPROCESSO.PENSAO_NAO_PROPRIA)
            this.GetUfProcReq();
          else {
            this.montarAnos();
            this.montarMeses();
            this.GetUfReq();
          }

          if (this.DADOSPROCESSO.PENSAO_PROPRIA == 'N') {
            if (this.DADOSPROCESSO.PENSAO_NAO_PROPRIA == '') {
              errorMessage += '-Procurador/Representante Legal';
            }
          }

          break;
        case 2:
          if (this.DADOSPROCESSO.PENSAO_NAO_PROPRIA) {
            errorMessage += this.validarProcRep();

            this.montarAnos();
            this.montarMeses();
            this.GetUfReq();
          } else {
            errorMessage += this.validarRequerente();
          }

          break;
        case 3:
          if (this.DADOSPROCESSO.PENSAO_NAO_PROPRIA) {
            errorMessage += this.validarRequerente();
          }
          else {
            errorMessage += this.validarInstituidor();

            if (errorMessage.length == noError)
              this.carregarDocumentos(this.chkListId.toString(), this.montarFiltroDocumentos());
          }

          break;
        case 4:
          if (this.DADOSPROCESSO.PENSAO_NAO_PROPRIA) {
            errorMessage += this.validarInstituidor();

            if (errorMessage.length == noError)
              this.carregarDocumentos(this.chkListId.toString(), this.montarFiltroDocumentos());
          }
          else {
            errorMessage = this.validarDocumentos();

            if (!errorMessage)
              errorMessage = "Ausência de preenchimento dos seguintes campos:\n";

            if (errorMessage.length == noError) {
              this.ConfirmarAberturaProcesso();
              return;
            }
          }

          break;
        case 5:
          errorMessage = this.validarDocumentos();

          if (!errorMessage)
            errorMessage = "Ausência de preenchimento dos seguintes campos:\n";

          if (errorMessage.length == noError) {
            this.ConfirmarAberturaProcesso();
            return;
          }

          break;
      }
    }
    else {
      switch (this.etapaAberturaProcesso) {
        case 0:
          this.carregarDocumentos(this.chkListId, "0");
          break;
      }
    }

    if (errorMessage.length > noError) {
      swal({
        title: "Atenção!",
        type: "error",
        text: errorMessage
      });
    } else {
      this.etapaAberturaProcesso += 1;
      this.etapaTabProcesso = this.etapaAberturaProcesso - 1;
    }
  }

  montarFiltroDocumentos(): string {
    var filtro: string = "";

    if (this.DADOSPROCESSO.ORGAO_VINCULO != "1") {
      filtro += "A,";
    }

    if (this.DADOSPROCESSO.ORGAO_VINCULO == "1") {
      filtro += "N,";
    }

    if (this.DADOSPROCESSO.ADERIR_AO_SC_SAUDE == "S") {
      filtro += "B,";
    }

    if (this.DADOSPROCESSO.RECEBE_PENSAO == "S") {
      filtro += "C,";
    }

    if (this.DADOSPROCESSO.SITUACAO_NO_OBITO == "A") {
      filtro += "D,";
    }

    if (this.DADOSPROCESSO.SITUACAO_NO_OBITO == "I") {
      filtro += "E,";
    }

    if (this.DADOSPROCESSO.PENSAO_NAO_PROPRIA == "P") {
      filtro += "F,";
    }

    if (this.DADOSPROCESSO.PENSAO_NAO_PROPRIA == "R") {
      filtro += "G,";
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == 2) {
      if (this.DADOSPROCESSO.REQUERENTE_CERT_DEC == "S") {
        filtro += "H,";
      }

      if (this.DADOSPROCESSO.REQUERENTE_HA_FILHOS == "S") {
        filtro += "K,";
      }
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == 2 || this.DADOSPROCESSO.TIPO_DEPENDENTE == 5) {
      if (this.DADOSPROCESSO.INSTITUIDOR_JA_CASOU == "S") {
        filtro += "I,";
      }

      if (this.DADOSPROCESSO.REQUERENTE_JA_CASOU == "S") {
        filtro += "J,";
      }
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == 5 || this.DADOSPROCESSO.TIPO_DEPENDENTE == 6) {
      if (this.DADOSPROCESSO.REQUERENTE_TIPO_DOC_DIVOR == "D") {
        filtro += "L,";
      }

      if (this.DADOSPROCESSO.REQUERENTE_TIPO_DOC_DIVOR == "E") {
        filtro += "M,";
      }
    }

    if (!filtro)
      filtro = "0";

    return filtro;
  }

  validarDocumentos(): string {
    let errorMessage = 'Foram identificadas as seguintes pendências:\n\n';
    let errorMessageEmpty = errorMessage.length;

    let pendentes = this.documentosObrigatorios.filter((obj) => {
      return obj.file === null;
    });

    for (let index = 0; index < pendentes.length; index++) {
      errorMessage += '-Documento "' + pendentes[index].name + '" não anexado\n';
    }

    if (!this.gerouRequerimento && this.beneficioSelecionado.BENEFICIO_ID == "7")
      errorMessage += '-Documento "REQUERIMENTO" não gerado\n';

    if (errorMessage.length == errorMessageEmpty)
      errorMessage = "";

    return errorMessage;
  }

  validarRequerente(): string {
    let errorMessage = "";

    if (!this.DADOSPROCESSO.REQUERENTE_NOME)
      errorMessage += "-Nome\n";

    if (!this.DADOSPROCESSO.REQUERENTE_CPF || this.DADOSPROCESSO.REQUERENTE_CPF.length < 11)
      errorMessage += "-CPF\n";

    if (this.DADOSPROCESSO.REQUERENTE_SEXO == "0")
      errorMessage += "-Sexo\n";

    if (!this.DADOSPROCESSO.REQUERENTE_DATA_NASC || !this.dataValida(this.DADOSPROCESSO.REQUERENTE_DATA_NASC))
      errorMessage += "-Data de Nascimento\n";

    if (!this.DADOSPROCESSO.REQUERENTE_EMAIL)
      errorMessage += "-E-mail\n";

    if (!this.DADOSPROCESSO.REQUERENTE_FONE || this.DADOSPROCESSO.REQUERENTE_FONE.length < 11)
      errorMessage += "-Telefone\n";

    if (!this.DADOSPROCESSO.REQUERENTE_CEP || this.DADOSPROCESSO.REQUERENTE_CEP.length < 8)
      errorMessage += "-CEP\n";

    if (!this.DADOSPROCESSO.REQUERENTE_LOGR)
      errorMessage += "-Logradouro\n";

    if (!this.DADOSPROCESSO.REQUERENTE_BAIRRO)
      errorMessage += "-Bairro\n";

    if (!this.DADOSPROCESSO.REQUERENTE_NUMERO)
      errorMessage += "-Número\n";

    if (!this.DADOSPROCESSO.REQUERENTE_UF)
      errorMessage += "-UF\n";

    if (!this.DADOSPROCESSO.REQUERENTE_CIDADE)
      errorMessage += "-Município\n";

    if (!this.DADOSPROCESSO.REQUERENTE_RG)
      errorMessage += "-RG\n";

    if (!this.DADOSPROCESSO.REQUERENTE_ORG_EXP)
      errorMessage += "-Orgão Emissor\n";

    if (!this.DADOSPROCESSO.REQUERENTE_UF_EXP)
      errorMessage += "-UF\n";

    if (!this.DADOSPROCESSO.REQUERENTE_PROFISSAO)
      errorMessage += "-Profissão\n";

    if (!this.DADOSPROCESSO.REQUERENTE_AGENCIA)
      errorMessage += "-Agência\n";

    if (!this.DADOSPROCESSO.REQUERENTE_AGENCIA)
      errorMessage += "-Conta Corrente\n";

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == 1 || this.DADOSPROCESSO.TIPO_DEPENDENTE == 2 ||
      this.DADOSPROCESSO.TIPO_DEPENDENTE == 5 || this.DADOSPROCESSO.TIPO_DEPENDENTE == 6 ||
      this.DADOSPROCESSO.TIPO_DEPENDENTE == 7 || this.DADOSPROCESSO.TIPO_DEPENDENTE == 8 ||
      this.DADOSPROCESSO.TIPO_DEPENDENTE == 12) {
      if (!this.DADOSPROCESSO.REQUERENTE_MAE)
        errorMessage += "-Nome da Mãe\n";
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == 1 ||
      this.DADOSPROCESSO.TIPO_DEPENDENTE == 2) {
      if (!this.DADOSPROCESSO.REQUERENTE_DATA_CONV || !this.dataValida(this.DADOSPROCESSO.REQUERENTE_DATA_CONV))
        errorMessage += "-Data de início da convivência com o Instituidor\n";
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == 3 || this.DADOSPROCESSO.TIPO_DEPENDENTE == 7 ||
      this.DADOSPROCESSO.TIPO_DEPENDENTE == 10) {
      if (!this.DADOSPROCESSO.REQUERENTE_DOENCA)
        errorMessage += "-Doença Incapacitante\n";

      if (!this.DADOSPROCESSO.REQUERENTE_DOENCA)
        errorMessage += "-CID\n";

      if (!this.DADOSPROCESSO.REQUERENTE_DATA_DIAG || !this.dataValida(this.DADOSPROCESSO.REQUERENTE_DATA_DIAG))
        errorMessage += "-Data do Diagnóstico\n";
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == 5 ||
      this.DADOSPROCESSO.TIPO_DEPENDENTE == 6) {
      if (!this.DADOSPROCESSO.REQUERENTE_TIPO_DOC_DIVOR)
        errorMessage += "-Documento de Separação/Divórcio\n";
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == 12) {
      if (!this.DADOSPROCESSO.REQUERENTE_MAE_CPF)
        errorMessage += "-CPF da Mãe\n";
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == "3" || this.DADOSPROCESSO.TIPO_DEPENDENTE == "10") {
      if (!this.DADOSPROCESSO.REQUERENTE_ESTADO_CIVIL)
        errorMessage += "-Estado Civil\n";

      if (!this.DADOSPROCESSO.REQUERENTE_GRAU)
        errorMessage += "-Grau de Instrução\n";
    }

    if (this.DADOSPROCESSO.TIPO_DEPENDENTE == "7") {
      if (!this.DADOSPROCESSO.REQUERENTE_GRAU) {
        errorMessage += "-Grau de Instrução\n";
      }
    }

    return errorMessage;
  }

  validarProcRep(): string {
    let errorMessage = "";

    if (!this.DADOSPROCESSO.PROC_REQ_NOME)
      errorMessage += "-Nome\n";

    if (!this.DADOSPROCESSO.PROC_REQ_CPF || this.DADOSPROCESSO.PROC_REQ_CPF.length < 11)
      errorMessage += "-CPF\n";

    if (!this.DADOSPROCESSO.PROC_REQ_EMAIL)
      errorMessage += "-E-mail\n";

    if (!this.DADOSPROCESSO.PROC_REQ_FONE || this.DADOSPROCESSO.PROC_REQ_FONE.length < 11)
      errorMessage += "-Telefone\n";

    if (!this.DADOSPROCESSO.PROC_REQ_RG)
      errorMessage += "-Doc. de Identidade\n";

    if (!this.DADOSPROCESSO.PROC_REQ_ORG_EXP)
      errorMessage += "-Orgão Expedidor\n";

    if (!this.DADOSPROCESSO.PROC_REQ_CEP || this.DADOSPROCESSO.PROC_REQ_CEP.length < 8)
      errorMessage += "-CEP\n";

    if (!this.DADOSPROCESSO.PROC_REQ_LOGR)
      errorMessage += "-Logradouro\n";

    if (!this.DADOSPROCESSO.PROC_REQ_BAIRRO)
      errorMessage += "-Bairro\n";

    if (!this.DADOSPROCESSO.PROC_REQ_COMP)
      errorMessage += "-Complemento\n";

    if (!this.DADOSPROCESSO.PROC_REQ_UF)
      errorMessage += "-UF\n";

    if (!this.DADOSPROCESSO.PROC_REQ_CIDADE)
      errorMessage += "-Município\n";

    if (this.DADOSPROCESSO.PENSAO_NAO_PROPRIA == 'R' && this.DADOSPROCESSO.PROC_REQ_TIPO_VINC_REQ == '0')
      errorMessage += "-Tipo de vínculo com o Requerente\n";

    return errorMessage;
  }

  validarInstituidor(): string {
    let errorMessage = "";

    if (!this.DADOSPROCESSO.INSTITUIDOR_ID)
      errorMessage += "-Instituidor\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_NOME)
      errorMessage += "-Nome\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_CPF || this.DADOSPROCESSO.INSTITUIDOR_CPF.length < 11)
      errorMessage += "-CPF\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_SEXO)
      errorMessage += "-Sexo\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_DATA_NASC || !this.dataValida(this.DADOSPROCESSO.INSTITUIDOR_DATA_NASC))
      errorMessage += "-Data de Nascimento\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_DATA_OBITO || !this.dataValida(this.DADOSPROCESSO.INSTITUIDOR_DATA_OBITO))
      errorMessage += "-Data do Óbito\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_DATA_EX_CERT_OBI || !this.dataValida(this.DADOSPROCESSO.INSTITUIDOR_DATA_EX_CERT_OBI))
      errorMessage += "-Data da Emissão da Certidão do Óbito\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_MAT_ORG)
      errorMessage += "-Matrícula\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_DATA_INI_SERV_PUB || !this.dataValida(this.DADOSPROCESSO.INSTITUIDOR_DATA_INI_SERV_PUB))
      errorMessage += "-Data de Início no Serviço Público\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_NUM_RG)
      errorMessage += "-Número do RG\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_ORG_EXP)
      errorMessage += "-Orgão Emissor\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_UF_EXP)
      errorMessage += "-UF Emissão\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_CEP || this.DADOSPROCESSO.INSTITUIDOR_CEP.length < 8)
      errorMessage += "-CEP\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_LOGR)
      errorMessage += "-Logradouro\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_BAIRRO)
      errorMessage += "-Bairro\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_NUMERO)
      errorMessage += "-Número\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_UF)
      errorMessage += "-UF\n";

    if (!this.DADOSPROCESSO.INSTITUIDOR_CIDADE)
      errorMessage += "-Município\n";

    if (this.DADOSPROCESSO.ORGAO_VINCULO != 1) {
      if (!this.DADOSPROCESSO.INSTITUIDOR_ULTIMO_SALARIO) {
        errorMessage += "-Último salário/subsídio\n";
      }

      if (!this.DADOSPROCESSO.INSTITUIDOR_CARGO) {
        errorMessage += "-Cargo\n";
      }
    }

    return errorMessage;
  }

  public VoltarEtapaAberturaProcesso() {
    this.etapaAberturaProcesso -= 1;
    this.etapaTabProcesso -= 1;
  }

  public fecharAbeturaProcesso() {
    switch (this.etapaAberturaProcesso) {
      case 0:
        $("#ModalMeusProcessos").hide();
        break;
      default:
        this.etapaAberturaProcesso = 0;
        this.etapaTabProcesso = 0;
        break;
    }
  }

  fecharProtocoloSenhaEletronica() {
    $('#ModalMeusProcessos').modal('show');
    $('#ModalProtocoloAssinaturaEletronica').modal('hide');
  }

  solicitarProcesso(): void {
    if (this.beneficioSelecionado.BENEFICIO_ID == "7") {
      Swal.fire({
        title: "Atenção!",
        text: "Deseja Confirmar a Solicitação de Pensão por Morte?",
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'SIM',
        cancelButtonText: 'NÃO'
      }).then((result) => {
        if (result.value) {
          this.AvancarEtapaAberturaProcesso();
        }
      });
    }
    else {
      let errorMessage = this.validarDocumentos();

      if (errorMessage) {
        swal({
          title: "Atenção!",
          type: "error",
          text: errorMessage
        });
      }
      else {
        this.SENHA_ELETRONICA = "";

        $('#ModalMeusProcessos').modal('hide');
        $('#ModalProtocoloAssinaturaEletronica').modal('show');
      }
    }
  }

  async ValidarAssinaturaEletronica() {
    this.Mostrar = true;

    var dados = {
      UserId: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
      Password: this.SENHA_ELETRONICA
    };

    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    options.responseType = ResponseContentType.Json;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/ValidarAssinaturaEletronica", JSON.stringify(dados), options)
      .map((res) => res.json())
      .subscribe(
        data => {
          if (data.VALIDA == "S") {
            this.Mostrar = false;

            $('#ModalProtocoloAssinaturaEletronica').modal('hide');

            this.ConfirmarAberturaProcesso();
          }
          else {
            this.Mostrar = false;

            Swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Senha informada não é válida!"
            });
          }
        },
        error => {
          this.Mostrar = false;

          Swal.fire({
            title: "Atenção!",
            type: "error",
            text: error._body.Message
          });
        }
      );
  }

  async ConfirmarAberturaProcesso() {
    var dados = {
      seguradoId: this.beneficioSelecionado.BENEFICIO_ID == 7 ? this.DADOSPROCESSO.INSTITUIDOR_ID : this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
      tipoProcesso: this.DADOSPROCESSO.TIPO_PROCESSO,
      chkListId: this.DADOSPROCESSO.TIPO_CHECKLIST,
      configRegraId: 0,
      revisao: false,
      Nome: "",
      dtCalculo: this.DADOSPROCESSO.INSTITUIDOR_DATA_OBITO,
      UserId: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
      cpf: this.beneficioSelecionado.BENEFICIO_ID == 7 ? this.DADOSPROCESSO.INSTITUIDOR_CPF : this.UtilDadosLogado.DadosAcesso().LOGIN,
      pessoaId: this.configuracoes.PESSOA_ID
    };

    this.Mostrar = true;

    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    options.responseType = ResponseContentType.Json;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/AbrirProcesso", JSON.stringify(dados), options)
      .map((res) => res.json())
      .subscribe(
        data => {
          if (data.PROCESSO_BENEFICIO_ID != 0) {
            this.processoId = data.PROCESSO_BENEFICIO_ID;

            this.EnviarArquivos(this).then((value) => {
              this.Mostrar = false;

              Swal.fire({
                title: "Atenção!",
                type: "success",
                text: "Solicitação enviada com sucesso!"
              }).then(() => {
                this.comprovanteProtocoloProcesso(data.ARQUIVOS_PROCESSO_ID);
                $('#ModalMeusProcessos').modal('hide');
              });
            }).catch(() => {
              this.Mostrar = false;

              Swal.fire({
                title: "Atenção!",
                type: "error",
                text: "Não foi possível enviar os documentos!"
              })
            }).then(() => {
              $('#ModalMeusProcessos').modal('show');
            });
          }
          else {
            this.Mostrar = false;

            Swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Ocorreu um erro durante a abertura do processo!"
            }).then(() => {
              $('#ModalMeusProcessos').modal('show');
            });
          }
        },
        error => {
          this.Mostrar = false;

          Swal.fire({
            title: "Atenção!",
            type: "error",
            html: error._body.Message
          }).then(() => {
            $('#ModalMeusProcessos').modal('show');
          });

        }
      );
  }

  ValidarNotificacao() {
    let notificacaoVisualizada = JSON.parse(localStorage.getItem('notificacaoVisualizada')) || {};
    let diff = new Date().valueOf() - new Date(notificacaoVisualizada.dataHora || new Date()).valueOf();
    let mesmoUsuario = (notificacaoVisualizada.usuarioId || this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID) == this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID;

    if (diff >= 0 || !mesmoUsuario) {
      this.UtilServico.Post("ValidarNotificacao", JSON.stringify({ SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID })).subscribe(
        result => {
          localStorage.setItem('notificacaoVisualizada', JSON.stringify({
            usuarioId: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
            dataHora: new Date(new Date().getTime() + 60 * 60 * 24 * 1000),
          }));

          let NUMERO_REPETICOES_CC_RESTANTES = result[0].NUMERO_REPETICOES_CC_RESTANTES;
          let NUMERO_REPETICOES_RENDIMENTO_RESTANTES = result[0].NUMERO_REPETICOES_RENDIMENTO_RESTANTES;

          let script = "";
          let script_aux = "";
          let duas_chamadas = false;

          if (NUMERO_REPETICOES_CC_RESTANTES > 0) {
            script = result[0].NOTIFICACAO_CONTRACHEQUE;
          }

          if (NUMERO_REPETICOES_RENDIMENTO_RESTANTES > 0) {
            if (!script) {
              script = result[0].NOTIFICACAO_RENDIMENTO;
            }
            else {
              script_aux = result[0].NOTIFICACAO_RENDIMENTO;
              duas_chamadas = true;
            }
          }

          if (script) {
            if (duas_chamadas) {
              Swal.fire({
                title: "Atenção!",
                type: "warning",
                html: script,
              }).then(function () {
                Swal.fire({
                  title: "Atenção!",
                  type: "warning",
                  html: script_aux,
                });
              });
            } else {
              Swal.fire({
                title: "Atenção!",
                type: "warning",
                html: script,
              });
            }
          }
        },
        error => {
          console.warn(error);
        }
      )
    };
  }

  public EnviarArquivos(self): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let formData: any;
      let promises: any = [];

      for (let index = 0; index < self.documentosObrigatorios.length; index++) {
        formData = new FormData();

        formData.append('oFile', self.documentosObrigatorios[index].file);
        formData.append('oFileName', self.documentosObrigatorios[index].fullName);
        formData.append('oFileFullName', self.documentosObrigatorios[index].name);
        formData.append('oProcessoId', self.processoId);
        formData.append('oTipoProcesso', this.DADOSPROCESSO.TIPO_PROCESSO);

        promises.push(self.EnviarArquivo(self, formData));
      }

      formData = new FormData();

      formData.append('oFile', self.requerimentoArquivo);
      formData.append('oFileName', "REQUERIMENTO.pdf");
      formData.append('oFileFullName', "REQUERIMENTO");
      formData.append('oProcessoId', self.processoId);
      formData.append('oTipoProcesso', this.DADOSPROCESSO.TIPO_PROCESSO);

      promises.push(self.EnviarArquivo(self, formData));

      Promise.all(promises).then(() => {
        resolve(true);
      }).catch(() => {
        reject(false);
      });
    });
  }

  public EnviarArquivo(self, formData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      self.http.put(self.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/PutArquivosProcesso", formData).pipe(map((res: Response) => res.json()))
        .subscribe(
          data => {
            if (data.SUCESSO == 1) {
              resolve(true);
            } else {
              reject(false)
            }
          },
          error => {
            reject(false);
          }
        );
    });
  }

  selecionarDocumento(uploadFileIndexToInsert: number): void {
    this.uploadFileIndexToInsert = uploadFileIndexToInsert;
    $("#hddFileUpload").click();
  }

  deletarDocumento(uploadFileIndexToDelete: number): void {
    Swal.fire({
      title: "Atenção!",
      text: "Deseja excluir o anexo?",
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'SIM',
      cancelButtonText: 'NÃO'
    }).then((result) => {
      if (result.value) {
        $("#hddFileUpload")[0].value = "";
        this.documentosObrigatorios[uploadFileIndexToDelete].file = null;;
      }
    });
  }

  handleFileInput(files: FileList) {
    var ext = files.item(0).name.match(/\.([^\.]+)$/)[1];

    switch (ext.toLowerCase()) {
      case 'pdf':
        if ((files.item(0).size / 1024 / 1024) <= 4) {
          this.documentosObrigatorios[this.uploadFileIndexToInsert].file = files.item(0);
          this.documentosObrigatorios[this.uploadFileIndexToInsert].fullName = files.item(0).name;
        } else {
          Swal.fire({
            title: "Atenção!",
            type: "error",
            text: "O arquivo ultrapassou o limite de tamanho de 4 megas."
          });
        }

        break;
      default:
        Swal.fire({
          title: "Atenção!",
          type: "error",
          text: "Formato do arquivo inválido!"
        });

        break;
    }

    $("#hddFileUpload")[0].value = "";
  }

  public carregarDocumentos(CHK_LIST_ID: string, filtro: string = "0"): void {
    this.Mostrar = true;

    this.UtilServico.Get("getDocumentosObrigatorios?CHK_LIST_ID=" + CHK_LIST_ID + "&FILTRO=" + filtro + "&TIPO=" + this.DADOSPROCESSO.TIPO_PROCESSO).subscribe(
      data => {
        this.Mostrar = false;
        this.documentosObrigatorios = [];

        for (let index = 0; index < data.length; index++) {
          this.documentosObrigatorios.push({ name: data[index].NOME_DOCUMENTO, fullName: "", file: null });
        }
      },
      error => {
        this.documentosObrigatorios = [];
        this.Mostrar = false;
      }
    );
  }

  public carregarProcessosBeneficio() {
    this.Mostrar = true;

    this.UtilServico.Get("GetProcessosAberturaPortal?categoriaId=" + this.configuracoes.CATEGORIA_ID + "&tipo=" + this.DADOSPROCESSO.TIPO_PROCESSO).subscribe(
      data => {
        this.Mostrar = false;
        this.chk_list = data;
      },
      error => {
        this.reiniciarProcesso();
        this.Mostrar = false;
      }
    );
  }

  public carregarInstituidores(event: any) {
    this.Mostrar = true;

    this.UtilServico.Post("getInstituidor", JSON.stringify({ CPF: event.target.txtPesquisaInstituidorCPF.value })).subscribe(
      data => {
        if (data.length == 0) {
          alert("Não foram encontrados registros para a pesquisa realizada!");
        }

        this.Mostrar = false;

        this.instituidores = data;
      },
      error => {
        this.Mostrar = false;
        this.instituidores = [];
        alert("Ocorreu um erro durante a pesquisa!");
      }
    );
  }

  //#region simulacao
  public Simulacao() {
    this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.DADOSSIMULACAO.Codigo = 0;
    this.UtilServico.Post("GetSimulacao", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.DADOS2 = data.Resultado[0];
          this.DADOS = this.DADOS2.Table[0];
          this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
          this.DADOS.DATA_ADM = this.datePipe.transform(this.DADOS.DATA_ADM, 'dd/MM/yyyy');
          this.DADOS.DATA_NASC = this.datePipe.transform(this.DADOS.DATA_NASC, 'dd/MM/yyyy');
        },
        error => {

        }
      );
  }

  public SimularSegurado(event: any) {
    this.BuscarDadosPrecarios().then((retorno) => {
      if (retorno.indexOf('COMPOSIÇÃO') > -1 && (this.parametrosSimulacao.VALOR_REL_SIMULACAO_PORTAL == "S" || this.parametrosSimulacao.VALOR_REL_REGRA_PORTAL == "S")) {
        swal({
          title: "Atenção!",
          type: "error",
          text: "Simulação permitida somente após a(s) correção(ões) do cadastro:\nSEGURADO SEM INFORMAÇÃO DE COMPOSIÇÃO REMUNERATÓRIA"
        });
      }
      else {
        this.ABONO_PERMANENCIA = "N";
        this.Mostrar = true;
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        let options = new RequestOptions({ headers: headers });
        this.UtilServico.Post("SimularSegurado", JSON.stringify({ SEGURADO_ID: event, DATA_CALC: this.DADOS2.DATA_CALC, DATA_NASC: this.DADOS.DATA_NASC, IDADE: this.DADOS.IDADE, ABONO_PERMANENCIA: "N" }))
          .subscribe(
            data => {
              this.Mostrar = false;
              this.DADOSSIMULACAO = data;
              if (data.Codigo == 0) {
                swal({
                  title: "Atenção!",
                  type: "error",
                  text: data.Msg
                });
              }
              else {
                this.DADOSSIMULACAO.Codigo = 1;
                this.TotalRegistro = data.Total;
                this.resultados = data.Resultado;
                this.exibirValorSimulacao = data.exibirValor;
              }
            },
            error => {

            }
          );
      }
    });
  }
  public ResultadoSimulacao(event: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    var dados = { RESULTADO_SIMULACAO_ID: event.RESULTADO_SIMULACAO_ID, SIMULA_REQUISITO_ID: event.SIMULA_REQUISITO_ID, TmpCarreira: event.TmpCarreira, SIMULA_ABONO: this.ABONO_PERMANENCIA };

    this.UtilServico.Post("GetResultadoSimulacao", JSON.stringify(dados), options)
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ResultadoSimulacao.pdf");
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  public RequerimentoProcesso() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.UtilServico.Post("GetRequerimentoProcesso", JSON.stringify(this.DADOSPROCESSO), options)
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.gerouRequerimento = true;
          this.requerimentoArquivo = new File([data], "REQUERIMENTO.pdf", { type: "application/pdf", lastModified: new Date().getTime() });
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  public comprovanteProtocoloProcesso(arquivosProcessoId: any) {
    this.Mostrar = true;

    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    options.responseType = ResponseContentType.Blob;

    this.UtilServico.Post("GetComprovanteProtocoloProcesso", JSON.stringify({ PROCESSO_BENEFICIO_ID: this.processoId, SEGURADO_ID: this.DADOSPROCESSO.INSTITUIDOR_ID, ARQUIVOS_PROCESSO_ID: arquivosProcessoId }), options)
      .subscribe(
        data => {
          this.Mostrar = false;

          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);

          window.open(fileURL);

          $('#ModalMeusProcessos').modal('hide');
          this.reiniciarProcesso();
        },
        error => {
          this.Mostrar = false;

          Swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Ocorreu um erro durante a geração do comprovante de protocolo."
          });

          $('#ModalMeusProcessos').hide();
          this.reiniciarProcesso();
        }
      );
  }
  public ExplicacaoRegra(event: any) {
    this.EXPLICACAOREGRA = event;
    $("#ModalSimulacaoExplicao").show();
    $("#ModalSimulacao").hide();
  }
  public SairExplicacaoRegra() {
    $("#ModalSimulacaoExplicao").hide();
    $("#ModalSimulacao").show();
  }

  public SairAnexo() {
    $("#ModalAnexo").hide();
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
  }
  public SimularSeguradoAbono(event: any) {
    this.ABONO_PERMANENCIA = "S";
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Post("SimularSegurado", JSON.stringify({ SEGURADO_ID: event, DATA_CALC: this.DADOS2.DATA_CALC, DATA_NASC: this.DADOS.DATA_NASC, IDADE: this.DADOS.IDADE, ABONO_PERMANENCIA: "S" }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSSIMULACAO = data;
          if (data.Codigo == 0) {
            swal({
              title: "Atenção!",
              type: "error",
              text: data.Msg
            });
          }
          else {
            this.DADOSSIMULACAO.Codigo = 1;
            this.TotalRegistro = data.Total;
            this.resultados = data.Resultado;
            this.exibirValorSimulacao = data.exibirValor;
          }
        },
        error => {

        }
      );
  }
  //#endregion simulacao

  //#region simulacaoespontanea
  public ExplicacaoRegraExpontanea(event: any) {
    this.EXPLICACAOREGRAEXPONTANEA = event;
    $("#ModalSimulacaoExplicaoExpontanea").show();
    $("#ModalSimulacaoEspontanea").hide();
  }
  public SairExplicacaoRegraExpontanea() {
    $("#ModalSimulacaoExplicaoExpontanea").hide();
    $("#ModalSimulacaoEspontanea").show();
  }
  public SimulacaoEspontanea() {
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Post("GetSimulacaoEspontanea", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.DADOS2 = data.Resultado[0];
          this.DADOS = this.DADOS2.Table[0];
          this.DADOS.DATA_ADM = this.datePipe.transform(this.DADOS.DATA_ADM, 'dd/MM/yyyy');
          this.DADOS.DATA_NASC = this.datePipe.transform(this.DADOS.DATA_NASC, 'dd/MM/yyyy');
          this.DADOS.ESPECIAL = "N";
          this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
          this.DADOS.DATA_CALC = this.DADOS2.DATA_CALC;
        },
        error => {

        }
      );
  }
  public SimularEspontanea(event: any) {

    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify(this.DADOS);
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.UtilServico.Post("GetGerarSimulacaoEspontanea", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      DATA_CALC: this.DADOS2.DATA_CALC, DATA_ADM: this.DADOS.DATA_ADM
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSSIMULACAOESPONTANEA = data;
          if (data.Codigo == 0) {
            swal({
              title: "Atenção!",
              type: "error",
              text: data.Msg
            });
          }
          else {
            this.DADOSSIMULACAOESPONTANEA.Codigo = 1;
            this.TotalRegistro = data.Total;
            this.resultados = data.Resultado;
          }
        },
        error => {
          this.Mostrar = false;
        }
      )
  }

  //#endregion simulacaoespontanea

  public Processos(event: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.UtilServico.Post("GetHistorico", JSON.stringify({ PROCESSO_ID: event }), options)
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "HistoricoProcesso.pdf");
        },
        error => {
          this.Mostrar = false;
        }
      );
  }


  public AbrirAnexo(event: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.UtilServico.Post('AbrirAnexo/' + event, options)
      .subscribe(
        data => {
          this.Mostrar = false;

          this.AbrirPDF(data);
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }

  public PossuiAnexo(event: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Post("GetListaAnexo", JSON.stringify({
      PROCESSO_ID: event
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          try {
            //this.AnexoProcesso=data.Resultado[0].Table;

            this.processoId = event;
            this.AnexoProcesso = data.Resultado[0].Table;
            this.mostrarAnexos = true;
          }
          catch {
            this.AnexoProcesso = null;
            this.mostrarAnexos = false;
          }

        },
        error => {
          this.Mostrar = false;
        }
      );
  }

  public ListaAnexo(event: any, proc: string) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Post("GetListaAnexo", JSON.stringify({
      PROCESSO_ID: event
    }))
      .subscribe(
        data => {
          this.Mostrar = false;

          try {
            this.processoId = event;
            this.nrProcesso = proc;
            this.AnexoProcesso = data.Resultado[0].Table;
            this.mostrarAnexos = false;
          }
          catch {
            this.AnexoProcesso = null;
            this.mostrarAnexos = false;
          }
          $("#ModalAnexo").modal('hide');
          $("#ModalAnexo").modal('show');
        },
        error => {
          this.Mostrar = false;
        }
      );
  }

  AbrirPDF(data) {

    var byteCharacters = atob(data);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    var file = new Blob([byteArray], { type: 'application/pdf;base64' });
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  }

  AlterSenha() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    if (this.SENHA.NOVA !== this.SENHA.CONFIRMA) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!"
      });
    }
    else {
      this.UtilServico.Post("GetTrocarSenha", JSON.stringify({ ATUAL: this.SENHA.ATUAL, NOVA: this.SENHA.NOVA, LOGIN: this.configuracoes.LOGIN, USR_LOGIN_ID: this.configuracoes.USR_LOGIN_ID }),)
        .subscribe(
          data => {
            this.Mostrar = false;
            this.TotalRegistro = data.Total;
            if (this.TotalRegistro == 0) {
              swal({
                title: "Atenção!",
                type: "error",
                text: "Senha atual não confere!"
              });
            }
            else {
              swal({
                title: "Atenção!",
                type: "success",
                text: "Senha alterada com sucesso!"
              });
            }
          },
          error => {
            this.Mostrar = false;
          }
        );
    }

  }

  AlterarAssinatura() {

    this.Mostrar = true;
    if (this.SENHA.NOVA !== this.SENHA.CONFIRMA) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!"
      });
      this.Mostrar = false;
      return
    }

    if (this.SENHA.NOVA === this.SENHA.ATUAL) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "Senha atual não confere!"
      });
      this.Mostrar = false;
      return
    }

    if (this.SENHA.NOVA.length < 6) {
      //s//wal({
      //title: "Atenção!",
      //type: "error",
      //text: "A nova senha conter no mínimo 6 caracteres! \n(letras ou números)",
      //text: "A nova senha deve conter no mínimo 6 caracteres! \n(letras ou números)"
      //});
      this.mostrarMSg = true;
      this.Mostrar = false;
    }

    else {
      this.UtilServico.Post("GetEditarAssinaturaEletronica", JSON.stringify({ ATUAL: this.SENHA.ATUAL, NOVA: this.SENHA.NOVA, LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN, USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID }))
        .subscribe(
          data => {
            this.Mostrar = false;
            this.TotalRegistro = data.Total;
            if (this.TotalRegistro == 0) {
              swal({
                title: "Atenção!",
                type: "error",
                text: "Senha atual não confere!"

              });
              this.mostrarMSg = false;
            }
            else {
              swal({
                title: "Atenção!",
                type: "success",
                text: "Senha alterada com sucesso!"
              });
              $("#ModalEditarAssinaturaDigital").hide();
              $(document.body).removeClass("modal-open");
              $(".modal-backdrop").remove();
              this.mostrarMSg = false;
            }
          },
          error => {
            this.Mostrar = false;
          }
        );
    }

  }

  CadastrarAssinatura() {


    this.Mostrar = true;
    if (this.SENHA.NOVA == undefined) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "Por favor, preencher o campo!"
      });
      this.Mostrar = false;
      return
    }

    this.Mostrar = true;
    if (this.SENHA.NOVA !== this.SENHA.CONFIRMA) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!"
      });
      this.Mostrar = false;
      this.mostrarMSg = false;
      return
    }

    if (this.SENHA.NOVA.length < 6) {
      //swal({
      // title: "Atenção!",
      // type: "error",
      //text: "A nova senha conter no mínimo 6 caracteres! \n(letras ou números)",
      //text: "A nova senha deve conter no mínimo 6 caracteres! \n(letras ou números)"

      //});
      this.Mostrar = false;
      this.mostrarMSg = true;
    }

    else {
      this.UtilServico.Post("GetCadastrarAssinaturaEletronica", JSON.stringify({ NOVA: this.SENHA.NOVA, LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN, USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID, NOME: this.UtilDadosLogado.DadosAcesso().NOME }))
        .subscribe(
          data => {
            this.Mostrar = false;
            if (data == "sucess") {
              swal({
                title: "Atenção!",
                type: "success",
                text: "Senha Cadastrada com sucesso!"
              });
              $("#ModalCadastrarAssinaturaDigital").hide();
              $(document.body).removeClass("modal-open");
              $(".modal-backdrop").remove();
              this.mostrarMSg = false;
            }
            else {
              swal({
                title: "Atenção!",
                type: "error",
                text: "Senha não cadastrada!"
              });
              this.mostrarMSg = false;
            }
          },
          error => {
            this.Mostrar = false;
          }
        );
    }

  }

  //#region faleconosco
  Assunto() {
    if (this.configuracoes.FONE_RESIDENCIAL != null)
      this.FALE.FONE_RESIDENCIAL = this.configuracoes.FONE_RESIDENCIAL;
    if (this.configuracoes.EMAIL1 != null)
      this.FALE.EMAIL1 = this.configuracoes.EMAIL1;
    this.UtilServico.Get("GetAssunto").subscribe(data => this.assunto = data, error => { });
  }
  setAssunto($event) {
    this.selectedAssuntoId = $event;
    for (var i = 0; i < this.assunto.length; i++) {
      if (this.assunto[i].ASSUNTO_ID == $event) {
        this.selectedAssunto = this.assunto[i].NOME;
      }
    }
  }

  FaleConosco() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });

    this.UtilServico.Post("GetFaleConosco", JSON.stringify({
      ASSUNTO_ID: this.selectedAssuntoId, ASSUNTO_NOME: this.selectedAssunto, EMAIL1: this.FALE.EMAIL1,
      FONE_RESIDENCIAL: this.FALE.FONE_RESIDENCIAL, DSC_ASSUNTO: this.FALE.DSC_ASSUNTO, NOME: this.configuracoes.NOME,
      USR_LOGIN_ID: this.configuracoes.USR_LOGIN_ID, SEXO: this.configuracoes.SEXO
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "success",
            text: "Sua mensagem foi enviada com sucesso!"
          });
          $("#ModalFaleConosco").modal('hide');
        },
        error => {
          swal({
            title: "Atenção!",
            type: "warning",
            text: "Não foi possível enviar sua mensagem, tente novamente mais tarde"
          });
          this.Mostrar = false;
        }
      );
  }
  //#endregion faleconosco

  //#region dadospessoais
  GetUf() {
    this.UtilServico.Get("GetUf").subscribe(
      data => {
        this.uf = data;
      },
      error => { }

    );
  }
  GetCidades() {
    this.UtilServico.Get("GetCidades/" + this.DADOSPESSOAIS.UF_NASCIMENTO).subscribe(
      data => {
        this.cidades = data;
      },
      error => { }

    );
  }
  GetUfProcReq() {
    this.UtilServico.Get("GetUf").subscribe(
      data => {
        this.ufProcReq = data;
      },
      error => { }

    );
  }
  GetCidadesProcReq() {
    this.DADOSPROCESSO.PROC_REQ_CIDADE = "";
    this.UtilServico.Get("GetCidades/" + this.DADOSPROCESSO.PROC_REQ_UF).subscribe(
      data => {
        this.cidadesProcReq = data;
      },
      error => { }

    );
  }
  GetUfReq() {
    this.UtilServico.Get("GetUf").subscribe(
      data => {
        this.ufReq = data;
      },
      error => { }

    );
  }
  GetCidadesReq() {
    this.DADOSPROCESSO.REQUERENTE_CIDADE = "";
    this.UtilServico.Get("GetCidades/" + this.DADOSPROCESSO.REQUERENTE_UF).subscribe(
      data => {
        this.cidadesReq = data;
      },
      error => { }

    );
  }
  GetCidadesInst(resetarValor: boolean = true) {
    if (resetarValor)
      this.DADOSPROCESSO.INSTITUIDOR_CIDADE = "";

    this.UtilServico.Get("GetCidades/" + this.DADOSPROCESSO.INSTITUIDOR_UF).subscribe(
      data => {
        this.cidadesInst = data;
      },
      error => { }

    );
  }
  GetUfByCidade(cidade: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.UtilServico.Get("GetUfByCidade?cidade=" + cidade).subscribe(
        data => {
          resolve(data.UF);
        },
        error => {
          resolve("");
        }
      );
    });
  }

  BuscarDadosPrecarios(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.UtilServico.Get("ValidarCadastroPrecario?seguradoId=" + this.configuracoes.SEGURADO_ID).subscribe(
        data => {
          resolve(data.Erros);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  GetSegurados() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Get("GetSegurados/" + this.configuracoes.PESSOA_ID)
      .subscribe(
        data => {
          this.segurados = data;

        },
        error => {

        }
      );
  }
  GetSeguradoInfo(event) {
    this.Mostrar = true;
    this.UtilServico.Get("GetSeguradoInfo/" + event).subscribe(
      data => {
        this.configuracoes = data;
        localStorage.setItem('DadosConfiguracoes', JSON.stringify(data))
        this.GetParametrosCategoriasPortal();
        this.Mostrar = false;
        this.VerificaPericiaMedica();
      },
      error => { this.Mostrar = false; }
    );
  }

  GetDadosRecad() {



    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Get("GetDadosRecad?id=" + this.configuracoes.SEGURADO_ID)
      .subscribe(
        data => {
          this.DADOS_RECADASTRAMENTO_AGENDADO = data[0];

        },
        error => {

        }
      );
  }

  GetNacionalidade() {
    this.UtilServico.Get("GetNacionalidade").subscribe(
      data => {
        this.nacionalidade = data;
      },
      error => { }

    );
  }

  GetRaca() {
    this.UtilServico.Get("GetRaca").subscribe(
      data => {
        this.raca = data;
      },
      error => { }

    );
  }

  Pessoas() {
    this.GetUf();
    this.GetNacionalidade();
    this.GetRaca();
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Post("GetPessoas", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.DADOSPESSOAIS = data.Resultado;
          this.DADOSPESSOAIS.DATA_NASC = this.datePipe.transform(this.DADOSPESSOAIS.DATA_NASC, 'dd/MM/yyyy');
          this.DADOSPESSOAIS.RG_DT_EMISSAO = this.datePipe.transform(this.DADOSPESSOAIS.RG_DT_EMISSAO, 'dd/MM/yyyy');
          this.DADOSPESSOAIS.CTPS_DT_EMISSAO = this.datePipe.transform(this.DADOSPESSOAIS.CTPS_DT_EMISSAO, 'dd/MM/yyyy');
          this.DADOSPESSOAIS.UF_NASCIMENTO = data.UF;
          this.DADOSPESSOAIS.END_UF = data.END_UF;
          if (this.DADOSPESSOAIS.UF_NASCIMENTO != null)
            this.GetCidades();
          if (this.DADOSPESSOAIS.NACIONALIDADE_ID == null)
            this.DADOSPESSOAIS.NACIONALIDADE_ID = 25;
        },
        error => {
          this.Mostrar = false;
        }
      );
  }
  public SalvarPessoas() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    if (this.parametrosPortal.PORTAL_CADASTRO_DIRETO === "S") {
      this.UtilServico.Put("PutPESSOAS/" + this.DADOSPESSOAIS.PESSOA_ID, this.DADOSPESSOAIS)
        .subscribe(
          data => {
            this.Mostrar = false;
            swal({
              title: "Atenção!",
              type: "success",
              text: "Cadastro atualizado com sucesso!"
            });
          },
          error => {
            this.Mostrar = false;
          }
        );
    }
    else {
      this.UtilServico.Put("PutPESSOAS_TEMP/" + this.DADOSPESSOAIS.PESSOA_ID, this.DADOSPESSOAIS)
        .subscribe(
          data => {
            this.Mostrar = false;
            swal({
              title: "Atenção!",
              type: "success",
              text: "Alteração de dados solicitada, aguarde confirmação!"
            });
          },
          error => {
            this.Mostrar = false;
          }
        );
    }
  }
  //#endregion dadospessoais

  //region extratocontrib
  public EmitirExtrato() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.UtilServico.Post("GetExtratoContrib", JSON.stringify({
      MES_INICIO: this.DADOCONTRIB.MES_INICIO, ANO_INICIO: this.DADOCONTRIB.ANO_INICIO,
      MES_FIM: this.DADOCONTRIB.MES_FIM, ANO_FIM: this.DADOCONTRIB.ANO_FIM, PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .subscribe(
        data => {
          this.Mostrar = false;
          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ExtratoContribuicao.pdf");
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion extratocontrib

  //#region holerite
  public EmitirHolerite() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.UtilServico.Post("GetHolerite", JSON.stringify({
      MES_INICIO: this.DADOHOLERITE.MES, ANO_INICIO: this.DADOHOLERITE.ANO,
      PESSOA_ID: this.configuracoes.PESSOA_ID, DECIMO: this.DADOHOLERITE.DECIMO,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .subscribe(
        data => {
          this.Mostrar = false;
          this.ConfigurarModalPdf(data, `Contracheque ${this.DADOHOLERITE.MES}-${this.DADOHOLERITE.ANO}`);
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }

  public EmitirHoleriteApi() {
    this.Mostrar = true;

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Blob
    });

    let caminho = '';
    this.http.get("assets/config.json").subscribe(data => {
      caminho = data.json().SISPREVWEB;
      var url = caminho + "/WebService/WebServiceHolerite.asmx/EmiteHolerite";

      let folhaativo = 0;
      if (this.configuracoes.CATEGORIA_ID !== 2 && this.configuracoes.CATEGORIA_ID !== 3) {
        folhaativo = 1;
      }

      this.http.post(
        url,
        JSON.stringify({
          request: {
            MesInicial: this.DADOHOLERITE.MES,
            AnoInicial: this.DADOHOLERITE.ANO,
            EmiteDecimo: this.DADOHOLERITE.DECIMO ? "S" : "N",
            SeguradoId: this.configuracoes.SEGURADO_ID,
            Portal: "S",
            Sigla: this.configuracoes.Sigla,
            FolhaAtivo: folhaativo
          }
        }),
        options
      ).subscribe(
        (data: any) => {
          this.Mostrar = false;
          if (data._body.size > 113)
            this.ConfigurarModalPdf(data._body, `Contracheque ${this.DADOHOLERITE.MES}-${this.DADOHOLERITE.ANO}`);
          else
            swal({
              title: "Atenção!",
              type: "error",
              text: "Nenhum registo encontrado!"
            });
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
    });
  }
  //#endregion holerite

  //#region fichafinanceira
  public EmitirFichaFinanceira() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.UtilServico.Post("GetFichaFinanceira", JSON.stringify({
      ANO_INICIO: this.DADOSFICHA.ANO,
      PESSOA_ID: this.configuracoes.PESSOA_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .subscribe(
        data => {
          this.Mostrar = false;
          this.ConfigurarModalPdf(data, `Ficha Financeira ${this.DADOHOLERITE.ANO}`);
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion fichafinanceira

  //region rendimentospagos
  public EmitirComprovanteRendimentos() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.UtilServico.Post("ComprovanteRendimentos", JSON.stringify({
      ANO_INICIO: this.DADOSRENDIMENTOS.ANO,
      PESSOA_ID: this.configuracoes.PESSOA_ID, USR_LOGIN_ID: this.configuracoes.USR_LOGIN_ID,
      SEGURADO_ID: this.configuracoes.SEGURADO_ID, MAT_ORG: this.configuracoes.MAT_ORG, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
    }), options)
      .subscribe(
        data => {
          this.Mostrar = false;
          this.ConfigurarModalPdf(data, "Comprovante de Rendimentos Pagos");
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      );
  }
  //#endregion rendimentospados

  //region parametros

  ExibirModalAlteracaoSenha() {
    if (this.exibirAlteracaoSenha == true) {
      $("div[id^=ModalTrocarSenha]").modal('show');
    }
  }

  //#endregion parametros

  //region parametros

  GetParametros() {
    this.UtilServico.Get("GetParametros/").subscribe(
      data => {
        this.parametros = data[0];
        //CHAMADO 414736
        //this.parametros.RECADASTRAMENTO = this.UtilDadosLogado.DadosAcesso().RECADASTRAMENTO;
        this.parametros.RECADASTRAMENTO_LINK = this.UtilDadosLogado.DadosAcesso().RECADASTRAMENTO_LINK;
        this.permiteAberturaDeProcessos = this.parametros.PORTAL_PERMITE_ABERTURA_PROCESSO == "S";
        this.exibirCampo = this.parametros.PORTAL_INFORMATIVOS == true;
        if (this.UtilDadosLogado.DadosAcesso().ATIVA_ASS_PORTAL == 'N') {
          $("#ModalCadastrarAssinaturaDigital").show();
        }
      },
      error => { }
    );
  }

  GetParametrosSimulacao() {
    this.UtilServico.Get("GetParametrosSimulacao/").subscribe(
      data => {
        this.parametrosSimulacao = data[0];
      },
      error => { }
    );
  }

  GetParametrosCategoriasPortal() {
    this.UtilServico.Post("GetParametrosCategoriasPortal", JSON.stringify({
      CATEGORIA_ID: this.configuracoes.CATEGORIA_ID,
      PESSOA_ID: this.configuracoes.PESSOA_ID, LOGIN: this.configuracoes.LOGIN
    })).subscribe(
      data => {
        this.parametrosPortal = data[0];
      },
      error => { }
    );
  }

  Links() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .get(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetLinks",
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.links = data;
        },
        (error) => { }
      )
      .add(() => (this.Mostrar = false));
  }

  //#endregion parametros

  //#region Boleto Arrecadação

  public BoletoArrecadacao() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetBoletos", JSON.stringify({
      SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID
    }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;
          this.BOLETOS_PORTAL = data
          this.BOLETOS_PORTAL = data;

          if (this.BOLETOS_PORTAL && this.BOLETOS_PORTAL.length > 0) {
            if (this.BOLETOS_PORTAL[0].TIPO_ID === 3) {
              this.tituloDocumento = 'Termo de Parcelamento';
            } else {
              this.tituloDocumento = 'Nº do Documento';
            }
          } else {
            this.tituloDocumento = 'Nº do Documento';
          }
        },
        error => {
          this.Mostrar = false;
          Swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!"
          });
        }
      )
  }

  EmitirBoletoArrecadacao(PARCELA_ID: any) {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GeraDadosBoleto", JSON.stringify({
      PARCELA_ID: PARCELA_ID,
      SeguradoId: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID
    }), options)
      .map((response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;

          if (this.isTypedArray(data) == true) {
            var file = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }
          else {
            Swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Não foi possível gerar o boleto!"
            });
          }
        },
        error => {
          this.Mostrar = false;
          Swal.fire({
            title: "Atenção!",
            type: "error",
            text: "O modelo do boleto gerado não está disponivel para impressão pelo portal!"
          });
        }
      );
  }


  SetarDadosCendente(DADOS_BOLETO: any) {
    if (DADOS_BOLETO != null && DADOS_BOLETO.length > 0) {
      this.DADOS_CEDENTE_BOLETO.CEDENTE = DADOS_BOLETO.CEDENTE;
      this.DADOS_CEDENTE_BOLETO.COMPETENCIA = DADOS_BOLETO.COMPETENCIA;
      this.DADOS_CEDENTE_BOLETO.FUNDO = DADOS_BOLETO.FORMA_FINANCIAMENTO;
    }
  }


  ParcelaEstaVencida(vencimento: any): boolean {
    if (!vencimento) return false;

    const hoje = new Date();
    hoje.setHours(0, 0, 0, 0);

    const dataVenc = new Date(vencimento);
    dataVenc.setHours(0, 0, 0, 0);

    return dataVenc < hoje;
  }

  isTypedArray(obj: any) {
    return obj.type == 'application/pdf';
  }

  //#endregion Boleto Arrecadação

  ConfigurarModalPdf(data: any, title: string) {
    var fileReader = new FileReader();
    fileReader.onload = () => {
      this.bytesPdf = fileReader.result;
      this.bytesPdfTitle = title;
      //exibe o modal, e ao fechar, adiciona novamente a classe .modal-open ao body
      //para não remover o scroll vertical do modal que está aberto atrás
      $("#ModalPdf").modal("show").on('hidden.bs.modal', function (e) {
        if ($(".modal.show").length) {
          $("body").addClass("modal-open");
        }
      });
    };
    fileReader.readAsArrayBuffer(data);
  }

  imprimirBytesPdf() {
    var blob = new Blob([new Uint8Array(this.bytesPdf)], { type: 'application/pdf' });
    if (blob) {
      var objectUrl = URL.createObjectURL(blob);
      const iframe = document.createElement('iframe');
      iframe.style.height = "1";
      iframe.style.opacity = "0";
      iframe.src = objectUrl;
      document.body.appendChild(iframe);

      var isFirefox = window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

      //No Firefox imprime direto embutindo pelo C# o jsPrint e renderizando dentro  doiFrame escondido (Não utilizar display:none!)
      //Nos demais, é necessário rodar o window.print();
      if (!isFirefox) {
        setTimeout(() => {
          iframe.contentWindow.window.print();
        }, 1000)

        // iframe.contentWindow.onload = () => {
        //   setTimeout(() => {
        //     iframe.contentWindow.window.print();
        //   }, 1000)
        // };
      }
    }
  }

  zoom_in() {
    this.zoom_to = this.zoom_to + 0.25;
  }

  zoom_out() {
    if (this.zoom_to > 0.5) {
      this.zoom_to = this.zoom_to - 0.25;
    }
  }

  downloadBytesPdf() {
    var file = new Blob([new Uint8Array(this.bytesPdf)], { type: 'application/pdf' });
    saveAs(file, this.bytesPdfTitle + ".pdf");
  }

  CarregarGridPericias() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.UtilServico.Post("GetPericias", JSON.stringify({ SEGURADO_ID: this.configuracoes.SEGURADO_ID }))
      .subscribe(
        data => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
          if (this.TotalRegistro == 0) {
            swal({
              title: "Atenção!",
              type: "warning",
              text: "Nenhum agendamento de perícia encontrado"
            });
          }
        },
        error => {

        }
      );
  }

  ConsultarPericias() {
    this.CarregarGridPericias();
  }

  CarregarMotivosPericia() {
    this.Mostrar = true;

    this.motivoPericia = "";
    this.dataPericia = null;

    this.UtilServico.Get(`GetMotivosPericia?tipo=${this.tipoPericia}`)
      .subscribe(
        data => {
          this.Mostrar = false;
          this.motivosPericia = data;
          if (this.motivosPericia == null || this.motivosPericia.length == 0) {
            swal({
              title: "Atenção!",
              type: "warning",
              text: "Nenhum motivo de perícia encontrado. Entre em contato com o suporte"
            });
          }
        },
        error => { }
      );

  }

  CarregarDatasPericia(event) {
    this.Mostrar = true;
    this.dataPericia = null;
    this.datasPericia = [];
    this.UtilServico.Get(`GetDatasPericia?tipo=${this.tipoPericia}&motivoPericiaId=${event}`).subscribe(
      data => {
        this.Mostrar = false;
        this.datasPericia = data;
      },
      error => { this.Mostrar = false; }
    );
  }

  dataPericiaChangeEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    let d = event.value;

    if (d != null) {
      const ano = d.getFullYear();
      const mes = String(d.getMonth() + 1).padStart(2, '0');
      const dia = String(d.getDate()).padStart(2, '0');

      const shortDate = `${ano}-${mes}-${dia}`;

      if (this.datasPericia.find((_d) => _d == shortDate) == null) {
        swal({
          title: "Atenção!",
          type: "error",
          text: "Data não disponível para realizar o agendamento!"
        });
        this.dataPericia = null;
      }
    }
  }

  consultarPericia() {
    let erro = "";
    if (!this.motivoPericia || this.motivoPericia == "")
      erro = "Selecione o motivo da perícia!";

    if (!this.dataPericia || !this.dataPericia)
      erro = "Selecione a data do agendamento!";

    if (erro != "") {
      swal({
        title: "Atenção!",
        type: "error",
        text: erro
      });
      return;
    }

    this.Mostrar = true;

    this.UtilServico.Get(`BloqueioAgendamentoPericia?Pessoa_id=${this.configuracoes.PESSOA_ID}` +
      `&Segurado_id=${this.configuracoes.SEGURADO_ID}` +
      `&data=${this.dataPericia.toLocaleDateString('pt-br')}` +
      `&Tipo=${this.tipoPericia}` +
      `&sima=` +
      `&motivo_id=${this.motivoPericia}` +
      `&estagio=`)
      .subscribe(
        data => {
          if (data.erro && data.erro != "") {
            swal({
              title: "Atenção!",
              type: "error",
              text: data.message
            });
            return;
          }

          this.consultarPeritos();
        },
        error => {
          swal({
            title: "Atenção!",
            type: "error",
            text: error
          });
        }
      )
      .add(() => this.Mostrar = false);
  }

  consultarPeritos() {
    this.Mostrar = true;

    this.peritos = [];

    this.UtilServico.Get(`GetPeritos?data=${this.dataPericia.toLocaleDateString('pt-br')}` +
      `&tipo_pericia=${this.tipoPericia}` +
      `&motivo_id=${this.motivoPericia}`)
      .subscribe(
        data => {
          if (!data || data.length == 0) {
            swal({
              title: "Atenção!",
              type: "warning",
              text: "Nenhum médico/perito disponível para a data informada"
            });
            return;
          }

          this.peritos = data;

          $("#ModalAgendarPericia").modal('hide');
          $("#ModalPeritos").modal('show');
        },
        error => {
          swal({
            title: "Atenção!",
            type: "warning",
            text: "Nenhum médico/perito disponível para a data informada"
          });
        }
      )
      .add(() => this.Mostrar = false);
  }

  AgendarPericia(p: Perito, turno: string) {
    if (!p) {
      swal('Verifique os dados informados e tente novamente!');
      return;
    }

    this.Mostrar = true;

    this.UtilServico.Get(`VerificaRetornoPericia?seguradoId=${this.configuracoes.SEGURADO_ID}&motivoId=${this.motivoPericia}&medicoId=${p.id}`)
      .subscribe(
        data => {
          if (data.retorno == "S") {
            //Todo: implementar retorno
            swal({
              title: "Atenção!",
              type: "error",
              text: `Perícia não agendada, última perícia do segurado(a) foi feita com o mesmo médico selecionado, favor selecionar outro médico para o agendamento!`
            });
            this.Mostrar = false;

            return;
          }

          const horario = turno == "M" ? p.atendimento_mat : p.atendimento_vesp;
          this.MarcarPericia(p.id, turno, horario);
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: error
          });
        }
      );
  }

  public mudarResposta(id: any) {
    for (let index = 0; index < this.dadosEnquete.RESPOSTAS.length; index++) {
      if (id == this.dadosEnquete.RESPOSTAS[index].ENQUETE_RESPOSTA_ID) {
        this.dadosEnquete.RESPOSTAS[index].SELECTED = true;
      } else {
        this.dadosEnquete.RESPOSTAS[index].SELECTED = false;
      }
    }
  }

  public enqueteVotar() {
    for (let index = 0; index < this.dadosEnquete.RESPOSTAS.length; index++) {
      if (this.dadosEnquete.RESPOSTAS[index].SELECTED) {
        this.Mostrar = true;
        let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
        let options = new RequestOptions({ headers: headers });

        this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/VotarEnquete", JSON.stringify({ ENQUETE_RESPOSTA_ID: this.dadosEnquete.RESPOSTAS[index].ENQUETE_RESPOSTA_ID, USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID }), options)
          .map((response: Response) => response.json())
          .subscribe(
            data => {
              this.Mostrar = false;

              this.dadosEnquete = null;
              this.mostrarEnquete = false;

              swal({
                title: "Sucesso!",
                type: "success",
                text: "A enquete foi votada com sucesso!"
              });
            },
            error => {
              this.Mostrar = false;
              this.mostrarEnquete = false;
              swal({
                title: "Atenção!",
                type: "error",
                text: "Ocorreu erro no momento da votação da enquete!"
              });
            }
          )
      }
    }
  }



  public ConsultarEnquete() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/ConsultarEnquete", JSON.stringify({ USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID }), options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.Mostrar = false;

          this.dadosEnquete = data.SUCCESS ? data : null;
          this.mostrarEnquete = data.SUCCESS;
        },
        error => {
          this.Mostrar = false;
          this.mostrarEnquete = false;
          swal({
            title: "Atenção!",
            type: "error",
            text: "Ocorreu erro na consulta das enquetes!"
          });
        }
      )
  }

  MarcarPericia(peritoId: string, turno: string, horario: string) {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    const dados = {
      "seguradoId": this.configuracoes.SEGURADO_ID,
      "pessoaId": this.configuracoes.PESSOA_ID,
      "tipo": this.tipoPericia,
      "motivoId": this.motivoPericia,
      "data": this.dataPericia,
      "medicoId": peritoId,
      "turno": turno,
      "horario": horario,
    };

    this.UtilServico.Post('MarcarPericia', dados, options)
      .subscribe(
        data => {
          $("#ModalPeritos").modal("hide");

          this.ConfigurarModalPdf(data, "Comprovante de Agendamento de Perícia Médica");

          swal({
            title: "Atenção!",
            type: "success",
            text: "Agendamento efetuado com sucesso!"
          });
        },
        error => {
          swal({
            title: "Atenção!",
            type: "error",
            text: "Ocorreu um erro ao efetuar o agendamento, entre em contato com o suporte!"
          });
        }
      )
      .add(() => this.Mostrar = false);
  }

  FecharModalPeritos() {
    $("#ModalPeritos").modal('hide');
    $("#ModalAgendarPericia").modal('show');
  }

  MontaLinkRecadastramento(): string {
    return this.parametros.RECADASTRAMENTO_LINK + btoa(this.configuracoes.LOGIN);
  }

  PerguntasFrequentes() {
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.get(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetPerguntasFrequentes", options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.perguntasFrequentes = data;
        },
        error => {
          Swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhuma pergunta cadastrada!"
          });
        }
      ).add(() => this.Mostrar = false);
  }

  mostrarAvisoInformativoNovo() {
    return this.informativos.filter(f => f.NOVO == 'S').length > 0
  }
  InformativoVisualizado() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });

    this.http.get(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetInformativos/" + this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID, options)
      .map((response: Response) => response.json())
      .subscribe(
        data => {
          this.informativos = data;
        },
        error => {

        }
      );
  }

  onButtonClick(item: any) {
    this.http.get(`${this.UtilDadosLogado.DadosAcesso().URL}/api/Inicial/InformativoVisualizado/${this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID}/${item.INFORME_ID}`)
      .subscribe(response => {
        this.informativos.forEach((f, i) => { if (f.INFORME_ID == item.INFORME_ID) this.informativos[i].NOVO = 'N'; });
      });
  }

  Informativos() {
    if (this.informativos.length == 0) {
      Swal.fire({
        title: "Atenção!",
        type: "error",
        text: "Nenhum informativo cadastrado!"
      });

    }
  }

  montarAnos(): void {
    this.anos = [];

    for (let i = 0; i <= 100; i++) {
      this.anos.push({ ID: i.toString() });
    }
  }

  montarMeses(): void {
    this.meses = [];

    for (let i = 0; i <= 11; i++) {
      this.meses.push({ ID: i.toString() });
    }
  }

  dataValida(date: string): boolean {
    var parsedDate = Date.parse(date);

    if (!isNaN(parsedDate)) {
      return true;
    } else {
      return false;
    }
  }

  showCalendar: boolean = false;
  selectedDate: Date;


  VerificaExisteAgendamento() {
    return new Promise((resolve, reject) => {
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
      let options = new RequestOptions({ headers: headers });
      this.UtilServico.Get("GetDadosRecad?id=" + this.configuracoes.SEGURADO_ID)
        .subscribe(
          data => {
            swal({
              title: "Atenção!",
              type: "error",
              text: "Agendamento já efetuado!"
            });

            resolve(true);
          },
          error => {
            resolve(false);
          }
        );
    });

  }

  VerificaExisteRecdastramento() {
    return new Promise((resolve, reject) => {
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
      let options = new RequestOptions({ headers: headers });
      this.UtilServico.Get("GetDadosRecadastramenoRealizado?id=" + this.configuracoes.SEGURADO_ID)
        .subscribe(
          data => {
            swal({
              title: "Atenção!",
              type: "error",
              text: "Recadastramento já efetuado para este Ano-Exercício!"
            });

            resolve(true);
          },
          error => {
            resolve(false);
          }
        );
    });

  }


  toggleCalendar(): void {
    this.VerificaExisteRecdastramento().then((possuiRecdastramento) => {
      if (!possuiRecdastramento) {
        this.VerificaExisteAgendamento().then((possuiAgendamento) => {
          if (!possuiAgendamento) {
            let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
            let options = new RequestOptions({ headers: headers });

            this.UtilServico.Get("GetDadosAgendamento?id=" + this.configuracoes.SEGURADO_ID)
              .subscribe(
                data => {

                  if (data[0] == null || data[0] == undefined) {
                    swal({
                      title: "Atenção!",
                      type: "warning",
                      text: "Não existe agendamento disponível!"
                    });
                  }
                  this.RECAD_AGENDAMENTO = data[0];
                  this.dataInicial = new Date(this.RECAD_AGENDAMENTO.DATA_INICIAL);
                  this.dataFinal = new Date(this.RECAD_AGENDAMENTO.DATA_FINAL);

                  this.dateClass = (date: Date): MatCalendarCellCssClasses => {

                    if (date <= this.dataInicial || date > this.dataFinal) {
                      return 'bloqueado';
                    }

                    const dayOfWeek = date.getDay();
                    if (dayOfWeek === 0 || dayOfWeek === 6) {
                      return 'bloqueado';
                    }
                    return '';
                  };

                  if (this.matCalendar) {
                    this.matCalendar.updateTodaysDate();
                  }

                  $('#ModalDataRecad').show();
                },
                error => {
                }
              );
          }
        });
      }
    });
  }

  GetDados(): void {



    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Get("GetDadosAgendamento?id=" + this.configuracoes.SEGURADO_ID)
      .subscribe(
        data => {
          this.RECAD_AGENDAMENTO = data[0];
          this.dataInicial = new Date(this.RECAD_AGENDAMENTO.DATA_INICIAL);
          this.dataFinal = new Date(this.RECAD_AGENDAMENTO.DATA_FINAL);

          this.dateClass = (date: Date): MatCalendarCellCssClasses => {

            if (date <= this.dataInicial || date > this.dataFinal) {
              return 'bloqueado';
            }

            const dayOfWeek = date.getDay();
            if (dayOfWeek === 0 || dayOfWeek === 6) {
              return 'bloqueado';
            }
            return '';
          };

          if (this.matCalendar) {
            this.matCalendar.updateTodaysDate();
          }

        },
        error => {

        }
      );
  }

  dateClass: MatCalendarCellCssClasses | undefined;

  formatardate(data) {
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  onDateSelect(event: any): void {
    this.selectedDate = event;
    this.DADOS_RECADASTRAMENTO.DataRecadastramento = this.datePipe.transform(event, 'dd/MM/yyyy');
  }



  confirm(): void {
    var dataHoje = new Date();
    const dataFormatada = this.formatardate(dataHoje)
    if (this.DADOS_RECADASTRAMENTO.DataRecadastramento === dataFormatada || this.DADOS_RECADASTRAMENTO.DataRecadastramento < dataFormatada) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "Data Indisponível! Favor selecionar o dia útil seguinte!"
      });
    }
    else {
      this.GetLocalRecad();
      this.GetDiasValidos();
      this.DADOS_RECADASTRAMENTO.Email = this.configuracoes.EMAIL1 && this.configuracoes.EMAIL1.trim() !== '' ? this.configuracoes.EMAIL1.trim() : "";
      this.DADOS_RECADASTRAMENTO.Telefone = this.configuracoes.FONE_RESIDENCIAL && this.configuracoes.FONE_RESIDENCIAL.trim() !== '' ? this.configuracoes.FONE_RESIDENCIAL.trim() : "";
    }
  }

  GetLocalRecad(): void {

    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Get("LocalRecad?id=" + this.RECAD_AGENDAMENTO.RECAD_LOCAL_ID)
      .subscribe(
        data => {
          this.Nome = data;
          if (this.Nome.length > 0) {
            this.RECAD_LOCAL = this.Nome;
          }
        },
        error => {
          this.closeModal();

          $('#ModalDadosRecad').show();
        }
      );
  }

  GetDiasValidos(): void {

    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Get("GetDiasValidos?data=" + this.DADOS_RECADASTRAMENTO.DataRecadastramento)
      .subscribe(
        data => {
          swal({
            title: "Atenção!",
            type: "error",
            text: "Data Indisponivel! Favor selecione um dia útil!"
          });

        },
        error => {
          this.closeModal();
          $('#ModalDadosRecad').show();
        }
      );
  }

  isModalVisible = false;

  showModal() {

    if (this.DADOS_RECADASTRAMENTO_AGENDADO !== undefined && this.DADOS_RECADASTRAMENTO_AGENDADO !== '' && this.DADOS_RECADASTRAMENTO_AGENDADO !== 0 && this.DADOS_RECADASTRAMENTO_AGENDADO.Periodo !== "null") {
      this.isModalVisible = true;
    }
  }

  hideModal() {
    this.isModalVisible = false;
  }



  closeModal(): void {
    $('#ModalDataRecad').hide();
  }

  closeModalDadosRecad(): void {
    $('#ModalDadosRecad').hide();
  }

  onSelectionChange(event: any): void {
    const selectedLocal = this.Nome.find(local => local.RECAD_LOCAL_ID === event.value);
    if (selectedLocal) {
      this.DADOS_RECADASTRAMENTO.Local = selectedLocal.NOME;
      this.DADOS_RECADASTRAMENTO.LocalId = selectedLocal.RECAD_LOCAL_ID;
      this.RECAD_LOCAL = selectedLocal;
    }
  }

  EnviarRecad() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;


    if (this.DADOS_RECADASTRAMENTO.Declarante === '') {
      swal({
        title: "Atenção!",
        type: "error",
        text: "É obrigatorio selecionar um declarante!"
      });
    }

    if (this.DADOS_RECADASTRAMENTO.Periodo === '' || this.DADOS_RECADASTRAMENTO.Periodo === null) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "É obrigatorio selecionar um período!"
      });
    }


    if (this.DADOS_RECADASTRAMENTO.Local === '' || this.DADOS_RECADASTRAMENTO.Local === null) {
      swal({
        title: "Atenção!",
        type: "error",
        text: "É obrigatorio selecionar um Local!"
      });
    }

    else if (this.DADOS_RECADASTRAMENTO.Periodo !== '' && this.DADOS_RECADASTRAMENTO.Declarante !== '' && this.DADOS_RECADASTRAMENTO.Local !== '') {
      this.DADOS_RECADASTRAMENTO.seguradoId = this.configuracoes.SEGURADO_ID;
      this.Mostrar = true;
      this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/Recadastramento", JSON.stringify(this.DADOS_RECADASTRAMENTO), options)
        .map((res) => res.json())
        .subscribe(
          data => {
            this.Mostrar = false;
            var file = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            $('#ModalDadosRecad').hide();
            window.location.reload();
          },
          error => {
            swal({
              title: "Atenção!",
              type: "error",
              text: "Não há agendamentos disponíveis para o local e período selecionados."
            });
            this.Mostrar = false;
          }
        );
    }
  }
  EmitirDoc() {

    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.Mostrar = true;
    this.http.post(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/EmiteProtoclo", JSON.stringify(this.DADOS_RECADASTRAMENTO), options)
      .map((res) => res.json())
      .subscribe(
        data => {
          this.Mostrar = false;

          var file = new Blob([data], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        },
        error => {
          swal({
            title: "Atenção!",
            type: "error",
            text: "Não foi possivel emitir o protocolo!"
          });
          this.Mostrar = false;
        }
      );
  }

  ExcluirAgendamento() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
    let options = new RequestOptions({ headers: headers });
    this.Mostrar = true;
    this.http.delete(this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/DeletaAgendamento?id=" + this.configuracoes.SEGURADO_ID)
      .subscribe(
        response => {
          this.Mostrar = false;
          swal({
            title: "Atenção!",
            type: "success",
            text: "Agendamento excluido com sucesso!"
          });
          this.hideModal();
          window.location.reload();
        },
        error => {
          this.Mostrar = false;
          swal({
            title: "error!",
            type: "error",
            text: "Não foi possivel excluir agendamento!"
          });
        }
      );
  }



  //#region recadastramento online

  abrirFormulario(): void {
    this.editando = false;
    this.showDependenteModal = true;
    this.novoDependente = { NOME: '', DATA_NASC: '', CPF: '', PARENTESCO: null, DATA_INI_DEP: '' };
  }

  excluirDependente(index: number): void {
    Swal.fire({
      title: "Tem certeza?",
      text: "Você realmente deseja excluir este dependente?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim, excluir",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.value) {
        this.RecadOnlineDadosDependete.splice(index, 1);
        Swal.fire({
          title: "Excluído!",
          text: "O dependente foi removido com sucesso.",
          type: "success",
          timer: 1000,
          showConfirmButton: false
        });
      }
    });
  }

  editarDependente(item: any): void {
    this.editando = true;
    this.indexEdicao = this.RecadOnlineDadosDependete.indexOf(item);

    const formattedItem = {
      ...item,
      DATA_NASC: formatDate(new Date(item.DATA_NASC), 'dd/MM/yyyy', 'pt-BR'),
      DATA_INI_DEP: formatDate(new Date(item.DATA_INI_DEP), 'dd/MM/yyyy', 'pt-BR')
    };

    this.novoDependente = formattedItem;
    this.showDependenteModal = true;
  }

  convertStringToDate(dateStr: string): Date {
    let day: string, month: string, year: string;

    if (dateStr.includes('/')) {
      [day, month, year] = dateStr.split('/');
    } else if (dateStr.length === 8) {
      day = dateStr.slice(0, 2);
      month = dateStr.slice(2, 4);
      year = dateStr.slice(4, 8);
    } else {
      return new Date(NaN);
    }

    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  }

  salvarDependente(): void {
    if (!this.novoDependente.NOME ||
      !this.novoDependente.DATA_NASC ||
      !this.novoDependente.CPF ||
      !this.novoDependente.PARENTESCO ||
      !this.novoDependente.DATA_INI_DEP) {
      alert("Preencha todos os campos!");
      return;
    }

    const dataNascimento = this.convertStringToDate(this.novoDependente.DATA_NASC);
    const dataInicio = this.convertStringToDate(this.novoDependente.DATA_INI_DEP);
    const parentescoSelecionado = this.listaParentesco.find(p => p.id === this.novoDependente.PARENTESCO).descricao || '';
    const sexo = this.listaSexo.find(s => s.id === this.novoDependente.SEXO).id || '';

    const dependente = {
      NOME: this.novoDependente.NOME.toUpperCase(),
      DATA_NASC: dataNascimento,
      SEXO: sexo,
      NOME_MAE: this.novoDependente.NOME_MAE.toUpperCase(),
      CPF: this.formatCPF(this.novoDependente.CPF),
      PARENTESCO: this.novoDependente.PARENTESCO,
      DATA_INI_DEP: dataInicio,
      tipo_Parentesco: parentescoSelecionado
    };

    if (this.editando && this.indexEdicao !== null) {
      this.RecadOnlineDadosDependete[this.indexEdicao] = dependente;
    } else {
      this.RecadOnlineDadosDependete.push(dependente);
    }

    this.fecharModal();
  }

  formatCPF(cpf: string): string {
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) {
      console.warn('CPF com quantidade de dígitos inválida.');
      return cpf;
    }
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  fecharModal(): void {
    this.showDependenteModal = false;
    this.indexEdicao = null;

  }

  adicionarDocumento() {
    if (!this.documentoSelecionado || !this.uploadedFile) {
      return;
    }
    var teste = [];
    const novoDocumento = {
      nome: this.documentoSelecionado.Nome,
      obrigatorio: this.documentoSelecionado.Obrigatorio,
      dados: this.documentoSelecionado.Dados,
      modelo: this.documentoSelecionado.Modelo,
      documentoId: this.documentoSelecionado.DocumentoId,
      formato: this.uploadedFile.type,
      url: this.docDadosRecOnline[0].dados,
      tipoDocumentoId: this.documentoSelecionado.Id
    };

    this.documentosAdicionados.push(novoDocumento);

    if (Array.isArray(this.docDadosRecOnline)) {
      this.docDadosRecOnline.length = 0; // método alternativo seguro
    } else {
      this.docDadosRecOnline = [];
    }
    this.RecadOnlineDadosDocumentos = this.RecadOnlineDadosDocumentos.filter(doc => doc !== this.documentoSelecionado);
    this.documentoSelecionado = null;
    this.limparUpload();
    this.verificarDocumento();
  }

  excluirDocumento(doc: any) {
    const index = this.documentosAdicionados.indexOf(doc);
    if (index >= 0) {
      this.documentosAdicionados.splice(index, 1);
    }
    if (!this.RecadOnlineDadosDocumentos.some(d => d.Nome === doc.nome)) {
      this.RecadOnlineDadosDocumentos.push({ Nome: doc.nome, Obrigatorio: doc.obrigatorio, Dados: doc.dados, Modelo: doc.modelo, DocumentoId: doc.documentoId });
    }
    this.RecadOnlineDadosDocumentos = this.RecadOnlineDadosDocumentos.slice();
    this.documentoSelecionado = null;
    this.verificarDocumento();
  }

  visualizarDocumento(doc: any) {
    if (!doc || !doc.url) {
      console.error('Documento inválido.');
      return;
    }

    let fileURL: string = '';

    if (typeof doc.url === 'string') {
      if (doc.url.startsWith('data:')) {
        // Se já estiver no formato data URL, usa diretamente
        fileURL = doc.url;
      } else {
        // Remove espaços e quebras de linha da string base64
        const base64Data = doc.url.replace(/\s/g, '');
        // Usa um mime type padrão se não for informado
        const mimeType = doc.formato || 'application/octet-stream';

        try {
          // Converte a string base64 para bytes
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          // Cria um Blob a partir dos bytes
          const blob = new Blob([byteArray], { type: mimeType });
          // Gera uma URL temporária para o Blob
          fileURL = URL.createObjectURL(blob);
        } catch (error) {
          console.error('Erro ao converter base64 para Blob:', error);
          return;
        }
      }
    } else if (doc.url instanceof Blob) {
      fileURL = URL.createObjectURL(doc.url);
    } else {
      console.error('Formato de URL não suportado.');
      return;
    }

    // Abre a URL em uma nova aba
    window.open(fileURL, '_blank');
  }


  limparUpload() {
    this.uploadedFile = null;
    this.pdfUrl = null;
    this.imageUrl = null;
  }

  verificarDocumento() {
    if (this.documentoSelecionado) {
      this.podeBaixarDocumento = !!(this.documentoSelecionado.Dados || this.documentoSelecionado.Modelo);
    } else {
      this.podeBaixarDocumento = false;
    }
    // Opcional: Limpa o arquivo enviado se o usuário trocar de documento
    this.uploadedFile = null;
    this.pdfUrl = null;
    this.imageUrl = null;
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fileArq = input.files[0]; // Obtém o primeiro arquivo selecionado
      const reader = new FileReader();

      reader.readAsDataURL(this.fileArq); // Converte para Base64

      reader.onload = () => {
        const base64String = reader.result as string;
        const base64Data = base64String.split(',')[1];
        const jaExiste = this.docDadosRecOnline.some(doc => doc.dados === base64Data);
        if (!jaExiste) {
          const docDadosRecOnline = { dados: base64Data };
          this.docDadosRecOnline.push(docDadosRecOnline);
        } else {
          this.docDadosRecOnline.push({ dados: base64Data });
        }
        const documentoArquivo = {
          SeguradoId: this.configuracoes.SEGURADO_ID,
          Nome: this.documentoSelecionado.Nome,
          Formato: this.fileArq.type,
          Url: base64Data
        };

        this.documentoArquivo.push(documentoArquivo);
      }
      this.uploadedFile = input.files[0];
      this.processFile(this.uploadedFile);
    }
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.uploadedFile = event.dataTransfer.files[0];
      this.processFile(this.uploadedFile);
      event.dataTransfer.clearData();
    }
  }


  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    // Remova a classe se adicionada
  }

  processFile(file: File) {

    const reader = new FileReader();

    reader.onload = () => {
      const base64String = reader.result as string;
      const novoArquivo = base64String.split(',')[1];
      const jaExiste = this.docDadosRecOnline.some(doc => doc.dados === novoArquivo);
      if (!jaExiste) {
        const docDadosRecOnline = { dados: novoArquivo };
        this.docDadosRecOnline.push(docDadosRecOnline);
      } else {
        this.docDadosRecOnline.push({ dados: novoArquivo });
      }
    };
    const fileType = file.type;
    const objectURL = URL.createObjectURL(file);
    if (fileType === 'application/pdf') {
      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectURL);
      this.imageUrl = null;
    } else if (fileType === 'image/png' || fileType === 'image/jpeg') {
      this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      this.pdfUrl = null;
    } else {
      this.uploadedFile = null;
      this.imageUrl = null;
      this.pdfUrl = null;
    }
    reader.readAsDataURL(file);
  }

  baixarDocumento() {
    if (!this.documentoSelecionado) return;

    if (this.documentoSelecionado.Dados) {
      const id = this.documentoSelecionado.DocumentoId;
      const url = this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/BaixarArquivo?id=" + id;
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
      let options = new RequestOptions({
        headers: headers,
        responseType: ResponseContentType.Blob
      });

      this.http.get(url, options)
        .map((response: Response) => response.blob())
        .subscribe(
          (blob: Blob) => {
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = fileURL;
            a.download = this.documentoSelecionado.Nome.replace(/\s+/g, '_') + ".docx";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(fileURL);
          },
          error => {
            this.pdfUrl = null;
          }
        );

    } else if (this.documentoSelecionado.Modelo) {
      const id = this.documentoSelecionado.DocumentoId;
      const url = this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/BaixarArquivoDoc?id=" + id;
      let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8' });
      let options = new RequestOptions({
        headers: headers,
        responseType: ResponseContentType.Blob
      });

      this.http.get(url, options)
        .map((response: Response) => response.blob())
        .subscribe(
          (blob: Blob) => {
            const fileURL = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = fileURL;
            a.download = this.documentoSelecionado.Nome.replace(/\s+/g, '_') + ".pdf";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(fileURL);
          },
          error => {
            console.error("Erro ao baixar o documento.", error);
          }
        );
    } else {
      console.error("Nenhum dado disponível para download.");
    }
  }

  base64ToArrayBuffer(base64: string): Uint8Array {
    const binaryString = atob(base64); // Decodifica Base64
    const length = binaryString.length;
    const bytes = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
  }

  RecadastramentoOnline() {
    this.GetUf();
    this.GetNacionalidade();
    this.GetRaca();
    this.Mostrar = true;
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Post("GetRecadOnlineDadosSegurados", JSON.stringify({
      PESSOA_ID: this.configuracoes.PESSOA_ID, CATEGORIA_ID: this.configuracoes.CATEGORIA_ID, SEGURADO_ID: this.configuracoes.SEGURADO_ID
    }))
      .subscribe(
        data => {
          this.Mostrar = false;
          if (data.Status && data.Status.length > 0) {
            swal({
              title: "Atenção!",
              type: "warning",
              text: data.Status[0].MensagemAlerta,
              timer: 60000,
              showConfirmButton: true
            });
          }

          if (data.ParametroSisRecad.length === 0) {
            swal({
              title: "Atenção!",
              type: "warning",
              text: "Aguarde o período para o seu recadastramento!"
            });
            return;
          }
          if (data.ParametroSisRecad) {
            this.ParametroRecadData = data.ParametroSisRecad;
            const dataNasc = new Date(data.Resultado.DATA_NASC);
            const mesNasc = dataNasc.getMonth() + 1;
            const dataAtual = new Date();
            const anoAtual = dataAtual.getFullYear();

            const primeiroRegistro = this.ParametroRecadData[0];
            this.paramMes = primeiroRegistro.MesAniversario;
            this.paramPeriodoRecad = primeiroRegistro.PeriodoRecadastramento;
            const parametrosValidos = this.ParametroRecadData.filter(x => {
              let valido = true;
              if (this.paramMes) {
                valido = valido && (x.Mes === mesNasc && x.Ano === anoAtual) && (new Date(x.DataInicio) <= dataAtual && new Date(x.DataFim) >= dataAtual);
              }
              if (this.paramPeriodoRecad) {
                valido = valido && (new Date(x.DataInicio) <= dataAtual && new Date(x.DataFim) >= dataAtual);
              }
              return valido;
            });
            if (!data.ValidaBeneficio) {
              swal({
                title: "Atenção!",
                icon: "warning",
                text: "Aguarde o período para o seu recadastramento!"
              });
              return;
            }
            if (parametrosValidos.length === 0) {
              swal({
                title: "Atenção!",
                icon: "warning",
                text: "Aguarde o período para o seu recadastramento!"
              });
              return;
            }
          }


          if (data.RecadOnline != null || data.RecadSisprev != null) {
            swal({
              title: "Salvo!",
              type: "success",
              text: "Você atualizou seus dados, aguarde a confirmação do seu recadastramento"
            });
            return;
          }
          $('#ModalRecadastramentoOnline').modal('show');

          this.RecadOnlineDados = data.Resultado;
          this.RecadOnlineDadosDependete = data.Dependente;
          this.RecadOnlineDadosDocumentos = data.ParametroSisRecadDoc;
          this.quantidadeDocumentosRecadOnline = this.RecadOnlineDadosDocumentos.length == 0 ? data.DocumentosAdicionados.length : this.RecadOnlineDadosDocumentos.length;
          this.ParametroRecadObritagorio = data.ParametroSisRecadObrigatorio;
          this.RecadOnlineDados.DATA_NASC = this.datePipe.transform(this.RecadOnlineDados.DATA_NASC, 'dd/MM/yyyy');
          this.RecadOnlineDados.RG_DT_EMISSAO = this.datePipe.transform(this.RecadOnlineDados.RG_DT_EMISSAO, 'dd/MM/yyyy');
          this.RecadOnlineDados.CTPS_DT_EMISSAO = this.datePipe.transform(this.RecadOnlineDados.CTPS_DT_EMISSAO, 'dd/MM/yyyy');
          this.RecadOnlineDados.UF_NASCIMENTO = data.UF;
          this.RecadOnlineDados.END_UF = data.END_UF;
          this.RecadOnlineDados.haDocObrigatorio = data.HaDocumentoObrigatorio;
          this.RecadOnlineDadosOriginais = { ...this.RecadOnlineDados };
          this.documentosAdicionados = data.DocumentosAdicionados;

          if (this.RecadOnlineDados.END_UF != null) {
            this.GetCidadesRecadOnline();
            this.GetCidadesRecadOnlineNacimento();
          }
          if (this.RecadOnlineDados.NACIONALIDADE_ID == null)
            this.RecadOnlineDados.NACIONALIDADE_ID = 25;
        },
        error => {
          this.Mostrar = false;
        }
      );
  }

  GetCidadesRecadOnline() {
    this.UtilServico.Get("GetCidades/" + this.RecadOnlineDados.END_UF).subscribe(
      data => {
        this.cidades = data;
      },
      error => { }

    );
  }

  GetCidadesRecadOnlineNacimento() {
    this.UtilServico.Get("GetCidades/" + this.RecadOnlineDados.UF_NASCIMENTO).subscribe(
      data => {
        this.cidadesNacionalidade = data;
      },
      error => { }

    );
  }

  onTabIndexChange(newIndex: number): void {
    if (newIndex > this.currentTabIndex) {
      let valid = false;
      switch (this.currentTabIndex) {
        case 0:
          valid = this.validarInformacoesTela();
          break;
        case 1:
          valid = this.validarDocumentosTela();
          break;
        case 2:
          valid = this.validarComplementoTela();
          break;
        case 3:
          valid = this.validarDependenteTela();
          break;
        default:
          valid = true;
      }
      if (valid) {
        if (this.currentTabIndex === 3) {
          this.AtualizacaoParcialRecadastramento(true);
        } else {
          this.AtualizacaoParcialRecadastramento();
        }
        this.currentTabIndex = newIndex;
      }
      else {

        if (this.myForm && this.myForm.control) {
          this.markFormGroupTouched(this.myForm.control);
        }
        setTimeout(() => {
          if (this.tabGroup) {
            this.tabGroup.selectedIndex = this.currentTabIndex;
          }
        });
      }
    } else {
      this.currentTabIndex = newIndex;
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  validarInformacoesTela(): boolean {
    const params = this.ParametroRecadObritagorio || {};
    const isValid = this.isFieldValid(params.NomePai, this.RecadOnlineDados.NOME_PAI) &&
      this.isFieldValid(params.Raca, this.RecadOnlineDados.RACA_ID) &&
      this.isFieldValid(params.EstadoCivil, this.RecadOnlineDados.ESTADO_CIVIL) &&
      this.isFieldValid(params.Nacionalidade, this.RecadOnlineDados.NACIONALIDADE_ID) &&
      this.isFieldValid(params.UfNascimento, this.RecadOnlineDados.UF_NASCIMENTO) &&
      this.isFieldValid(params.Naturalidade, this.RecadOnlineDados.NAT_CIDADE_ID);

    if (!isValid) {
      if (this.myForm && this.myForm.control) {
        this.markFormGroupTouched(this.myForm.control);
      }
      setTimeout(() => {
        if (this.tabGroup) {
          this.tabGroup.selectedIndex = this.currentTabIndex;
        }
      });
    }
    return isValid;
  }

  validarDocumentosTela(): boolean {
    const params = this.ParametroRecadObritagorio || {};
    const isValid = this.isFieldValid(params.Rg, this.RecadOnlineDados.RG_NUMERO) &&
      this.isFieldValid(params.OrgaoEmissor, this.RecadOnlineDados.RG_ORGAO) &&
      this.isFieldValid(params.DataEmissaoRg, this.RecadOnlineDados.RG_DT_EMISSAO) &&
      this.isFieldValid(params.TituloEleitor, this.RecadOnlineDados.TITULO_NR) &&
      this.isFieldValid(params.ZonaEleitoral, this.RecadOnlineDados.TITULO_ZONA) &&
      this.isFieldValid(params.Secao, this.RecadOnlineDados.TITULO_SECAO) &&
      this.isFieldValid(params.PisPasep, this.RecadOnlineDados.PIS) &&
      this.isFieldValid(params.Ctps, this.RecadOnlineDados.CTPS_NUMERO) &&
      this.isFieldValid(params.SerieCtps, this.RecadOnlineDados.CTPS_SERIE) &&
      this.isFieldValid(params.DataEmissaoCtps, this.RecadOnlineDados.CTPS_DT_EMISSAO) &&
      this.isFieldValid(params.UfCtps, this.RecadOnlineDados.CTPS_UF) &&
      this.isFieldValid(params.LocalExpedicaoCtps, this.RecadOnlineDados.CTPS_LOCAL_EXP);

    if (!isValid) {
      if (this.myForm && this.myForm.control) {
        this.markFormGroupTouched(this.myForm.control);
      }
      setTimeout(() => {
        if (this.tabGroup) {
          this.tabGroup.selectedIndex = this.currentTabIndex;
        }
      });
    }
    return isValid;
  }

  validarComplementoTela(): boolean {
    const params = this.ParametroRecadObritagorio || {};
    const isValid = this.isFieldValid(params.TipoLogradouro, this.RecadOnlineDados.TIPO_LOGRADOURO) &&
      this.isFieldValid(params.Endereco, this.RecadOnlineDados.END_RUA) &&
      this.isFieldValid(params.Numero, this.RecadOnlineDados.END_NUMERO) &&
      this.isFieldValid(params.Bairro, this.RecadOnlineDados.END_BAIRRO) &&
      this.isFieldValid(params.Cep, this.RecadOnlineDados.END_CEP) &&
      this.isFieldValid(params.UfResidencia, this.RecadOnlineDados.END_UF) &&
      this.isFieldValid(params.CidadeResidencia, this.RecadOnlineDados.END_CIDADE_ID) &&
      this.isFieldValid(params.Complemento, this.RecadOnlineDados.END_COMPLEMENTO) &&
      this.isFieldValid(params.TelefoneResid, this.RecadOnlineDados.FONE_RESIDENCIAL) &&
      this.isFieldValid(params.TelefoneCelular, this.RecadOnlineDados.FONE_CELULAR) &&
      this.isFieldValid(params.Email1, this.RecadOnlineDados.EMAIL1) &&
      this.isFieldValid(params.Email2, this.RecadOnlineDados.EMAIL2);

    if (!isValid) {
      if (this.myForm && this.myForm.control) {
        this.markFormGroupTouched(this.myForm.control);
      }
      setTimeout(() => {
        if (this.tabGroup) {
          this.tabGroup.selectedIndex = this.currentTabIndex;
        }
      });
    }
    return isValid;
  }

  validarDependenteTela(): boolean {
    return true;
  }

  isFieldValid(param: any, value: any): boolean {
    if (param && (value === null || value === undefined || value === '')) {
      return false;
    }
    return true;
  }

  public AtualizacaoParcialRecadastramento(isAbaDependente: boolean = false, salvarDocumentos: boolean = false, fecharModal: boolean = false) {
    let houveAtualizacaoDados = false;

    if (JSON.stringify(this.RecadOnlineDadosOriginais) !== JSON.stringify(this.RecadOnlineDados)) {
      houveAtualizacaoDados = true;
    }

    if (!houveAtualizacaoDados && !isAbaDependente) {
      return;
    }

    if (this.RecadOnlineDados.RG_DT_EMISSAO && this.RecadOnlineDados.RG_DT_EMISSAO.length === 8) {
      const dia = this.RecadOnlineDados.RG_DT_EMISSAO.substr(0, 2);
      const mes = this.RecadOnlineDados.RG_DT_EMISSAO.substr(2, 2);
      const ano = this.RecadOnlineDados.RG_DT_EMISSAO.substr(4, 4);
      const dataObj = new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
      this.RecadOnlineDados.RG_DT_EMISSAO = this.datePipe.transform(dataObj, 'dd/MM/yyyy')
    }

    const dadosParaSalvar = {
      Configuracoes: this.configuracoes,
      RecadOnlineDados: this.RecadOnlineDados,
      RecadOnlineDadosDependete: this.RecadOnlineDadosDependete,
      DocumentosAdicionados: salvarDocumentos ? this.documentosAdicionados : null
    };

    let headers = new Headers({
      'Content-Type': 'application/json; charset=utf-8',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE'
    });

    let options = new RequestOptions({ headers: headers });

    this.UtilServico.Post('RecadastramentoOnlineAtualizacaoParcial', JSON.stringify(dadosParaSalvar), options)
      .subscribe(
        data => {
          this.RecadOnlineDados = data.AtualizacaoParcial;
          this.RecadOnlineDadosDependete = data.Dependentes;
          this.RecadOnlineDados.DATA_NASC = this.datePipe.transform(this.RecadOnlineDados.DATA_NASC, 'dd/MM/yyyy');
          this.RecadOnlineDados.RG_DT_EMISSAO = this.datePipe.transform(this.RecadOnlineDados.RG_DT_EMISSAO, 'dd/MM/yyyy');
          this.RecadOnlineDados.CTPS_DT_EMISSAO = this.datePipe.transform(this.RecadOnlineDados.CTPS_DT_EMISSAO, 'dd/MM/yyyy');
          this.RecadOnlineDados.UF_NASCIMENTO = data.AtualizacaoParcial.UF_NASCIMENTO;
          this.RecadOnlineDados.END_UF = data.AtualizacaoParcial.END_UF;
          this.RecadOnlineDadosOriginais = { ...this.RecadOnlineDados };

          if (this.RecadOnlineDados.END_UF != null) {
            this.GetCidadesRecadOnline();
            this.GetCidadesRecadOnlineNacimento();
          }

          if (this.RecadOnlineDados.NACIONALIDADE_ID == null)
            this.RecadOnlineDados.NACIONALIDADE_ID = 25;

          if (fecharModal)
            $('#ModalRecadastramentoOnline').modal('hide');
        },
      );
  }

  public FecharRecadastramentoOnline() {
    if (this.validarInformacoesTela())
      this.AtualizacaoParcialRecadastramento(false, true, true);
  }

  public VoltarAbaRecadastramentoOnline() {
    this.previousTab();
  }

  public SalvarRecadastramento(): void {
    switch (this.currentTabIndex) {
      case 0:
        if (this.validarInformacoesTela()) {
          this.AtualizacaoParcialRecadastramento();
          this.nextTab();
          this.Mostrar = false;
        } else {
          alert('Por favor, preencha corretamente os dados de Informações.');
        }
        break;
      case 1:
        if (this.validarDocumentosTela()) {
          this.AtualizacaoParcialRecadastramento();
          this.nextTab();
        } else {
          alert('Verifique os dados dos Documentos.');
        }
        break;
      case 2:
        if (this.validarComplementoTela()) {
          this.AtualizacaoParcialRecadastramento();
          this.nextTab();
        } else {
          alert('Verifique os dados do Complemento.');
        }
        break;
      case 3:
        if (this.validarDependenteTela()) {
          this.AtualizacaoParcialRecadastramento(true);
          this.nextTab();
        } else {
          alert('Verifique os dados do Dependente.');
        }
        break;
      case 4:
        const documentosFaltando = this.verificarDocumentosFaltando();
        const haDocObrigatorioFaltando = documentosFaltando.some(doc => doc.obrigatorio === true);
        const textoFaltandoDocObrigatorio = `Para dar continuidade ao seu recadastramento, é
        imprescindível anexar o(s) documento(s) obrigatórios(s). Verifique a lista de documentos necessários antes de prosseguir.`;
        const textoFaltandoDocOpcional = `Deseja confirmar o recadastramento sem anexar o documento:`;
        if (documentosFaltando.length > 0) {
          Swal.fire({
            title: "Atenção!",
            type: "warning",
            html: `<p>${haDocObrigatorioFaltando ? textoFaltandoDocObrigatorio : textoFaltandoDocOpcional}</p>
         <div style="text-align: left;">
            <ul>
              ${documentosFaltando.map(doc => `
                <li>
                  ${doc.obrigatorio === true
                ? `<span>${doc.nome} <span style="color: red">(*obrigatório)</span></span>`
                : `<span>${doc.nome}</span>`
              }
                </li>
              `).join("")}
            </ul>
         </div>`,
            showCancelButton: true,
            showConfirmButton: !haDocObrigatorioFaltando,
            confirmButtonText: 'Concluir Recadastramento',
            cancelButtonText: "Voltar"
          }).then((result) => {
            if (result.value) {
              this.salvarDados();
            }
          });

          return;
        }
        this.salvarDados();
        break;
      default:
        break;
    }
  }

  private salvarDados(): void {
    if (this.validarDocumentosAnexadosTela()) {
      if (this.RecadOnlineDados.RG_DT_EMISSAO && this.RecadOnlineDados.RG_DT_EMISSAO.length === 8) {
        const dia = this.RecadOnlineDados.RG_DT_EMISSAO.substr(0, 2);
        const mes = this.RecadOnlineDados.RG_DT_EMISSAO.substr(2, 2);
        const ano = this.RecadOnlineDados.RG_DT_EMISSAO.substr(4, 4);
        const dataObj = new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
        this.RecadOnlineDados.RG_DT_EMISSAO = this.datePipe.transform(dataObj, 'dd/MM/yyyy')
      }

      const dadosParaSalvar = {
        Configuracoes: this.configuracoes,
        RecadOnlineDados: this.RecadOnlineDados,
        RecadOnlineDadosDependete: this.RecadOnlineDadosDependete,
        DocumentosAdicionados: this.documentosAdicionados
      };
      let headers = new Headers({
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE'
      });

      let options = new RequestOptions({ headers: headers });

      this.UtilServico.Post('RecadastramentoOnlineSalvar', JSON.stringify(dadosParaSalvar), options)
        .subscribe(
          data => {
            if (data.status === 200) {
              Swal.fire({
                title: "Salvo!",
                type: "success",
                text: "Você atualizou seus dados, aguarde a confirmação do seu recadastramento.",
                confirmButtonText: "OK"
              }).then(() => {
                if (document.activeElement instanceof HTMLElement) {
                  document.activeElement.blur();
                }
                $('#ModalRecadastramentoOnline').modal('hide');
                this.limparUpload();
              });
            } else {
              Swal.fire({
                title: "Atenção!",
                type: "error",
                text: "Ocorreu um erro ao salvar os dados. Entre em contato com o suporte!",
                confirmButtonText: "OK"
              });
            }
          },
          error => {
          }
        );
    } else {
      alert('Verifique os dados dos Documentos Anexados.');
    }
  }

  private nextTab(): void {
    this.currentTabIndex++;
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = this.currentTabIndex;
    }
  }

  private previousTab(): void {
    this.currentTabIndex--;
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = this.currentTabIndex;
    }
  }

  public resetModal(): void {
    this.currentTabIndex = 0;
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = 0;
    }
    this.limparUpload();
  }

  public fecharOuVoltar(): void {
    if (this.currentTabIndex === 0 || this.currentTabIndex === this.totalTabs - 1) {
      this.closeForm();
    } else {
      this.currentTabIndex--;
      if (this.tabGroup) {
        this.tabGroup.selectedIndex = this.currentTabIndex;
      }
    }
  }

  private closeForm(): void {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $('#ModalRecadastramentoOnline').modal('hide');
    this.limparUpload();
  }

  validarDocumentosAnexadosTela(): boolean {
    return true;
  }

  verificarDocumentosFaltando(): any[] {
    const documentosFaltando: any[] = [];

    const documentosObrigatorios = this.RecadOnlineDadosDocumentos.map(doc => ({ nome: doc.Nome, obrigatorio: doc.Obrigatorio }));

    const documentosAdicionados = this.documentosAdicionados.map(doc => ({ nome: doc.Nome, obrigatorio: doc.Obrigatorio }));

    documentosObrigatorios.forEach(doc => {
      if (!documentosAdicionados.includes(doc)) {
        documentosFaltando.push(doc);
      }
    });

    return documentosFaltando;
  }

  get textoBtnConcluirRecad(): string {
    if (this.currentTabIndex < this.totalTabs - 1) {
      return 'Avançar';
    }

    if (this.quantidadeDocumentosRecadOnline === this.documentosAdicionados.length) {
      return 'Concluir Recadastramento';
    }

    return 'Salvar';
  }

  //#endregion recadastramento online


  //#region Validações de campos

  public somenteLetra(event: KeyboardEvent) {
    const key = event.key;
    if (key.length > 1) {
      return;
    }
    const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  public bloqueaCtrlVSomenteLetra(event: ClipboardEvent): void {
    const pastedInput: string = event.clipboardData ? event.clipboardData.getData('text') : '';
    if (/\d/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  public onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  public bloqueaArrasto(event: DragEvent): void {
    const draggedInput: string = event.dataTransfer ? event.dataTransfer.getData('text') : '';
    if (/\d/.test(draggedInput)) {
      event.preventDefault();
    }
  }

  public somenteNumero(event: KeyboardEvent): void {
    const key = event.key;
    if (key.length > 1) {
      return;
    }
    const regex = /^[0-9]$/;
    if (!regex.test(key)) {
      event.preventDefault();
    }
  }

  public bloqueaCtrlVSomenteNumero(event: ClipboardEvent): void {
    const pastedInput: string = event.clipboardData ? event.clipboardData.getData('text') : '';
    if (/[^0-9]/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  public bloqueaArrastoNumeros(event: DragEvent): void {
    const draggedInput: string = event.dataTransfer ? event.dataTransfer.getData('text') : '';
    if (/[^0-9]/.test(draggedInput)) {
      event.preventDefault();
    }
  }

  //#endregion Validações de campos


  VerificaPericiaMedica() {
    let headers = new Headers({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE' });
    let options = new RequestOptions({ headers: headers });
    this.UtilServico.Get("GetVerificaPericia/" + this.configuracoes.SEGURADO_ID)
      .subscribe(
        html => {
          if (html != null && html != "") {
            Swal.fire({
              title: "Atenção!",
              type: "warning",
              html: `<div style="text-align: justify;">${html}</div>`
            });
          }
        },
        error => {

        }
      );
  }
}
